import translations from './i18n';

const ext = {
  th: {
    // common / buttons
    ap_ok: 'ตกลง',
    ap_confirm: 'ยืนยัน',
    ap_cancel: 'ยกเลิก',
    ap_back: 'กลับ',
    ap_back2: 'ย้อนกลับ',
    ap_next: 'ต่อไป',
    ap_copy: 'คัดลอก',
    ap_copied: 'คัดลอกแล้ว',
    ap_copied_excl: 'คัดลอกแล้ว!',
    ap_acknowledge: 'รับทราบ',
    ap_done: 'เรียบร้อย',
    ap_claim: 'เคลม',
    ap_baht: 'บาท',
    ap_credit_unit: 'เครดิต',
    ap_login: 'เข้าสู่ระบบ',
    ap_register: 'สมัครสมาชิก',
    ap_register_now: 'สมัครเลย',
    ap_login_short: 'เข้าระบบ',
    ap_deposit: 'ฝากเงิน',
    ap_withdraw: 'ถอนเงิน',
    ap_topup: 'เติมเงิน',
    ap_topup_payment: 'เติม Payment',
    ap_no_data: 'ไม่พบข้อมูล',
    ap_no_history: 'คุณยังไม่มีข้อมูลการทำรายการค่ะ',
    ap_no_affiliate: 'คุณยังไม่มีข้อมูลการชวนเพื่อนค่ะ',
    ap_no_cashback: 'คุณยังไม่มีข้อมูลรายการเงินคืน',

    // alerts / swal / notify
    ap_withdraw_insufficient: 'ยอดถอนของท่านไม่เพียงพอในการถอน',
    ap_session_expired: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
    ap_promo_pending_can_topup: 'ท่านใช้โปรโมชั่นค้างไว้ สามารถเติมเงินได้เลย',
    ap_promo_received: 'รับโปรโมชั่นเรียบร้อย',
    ap_promo_not_eligible: 'ท่านไม่เข้าเงื่อนใขโปรโมชั่นนี้',
    ap_quota_used_today: 'ท่านใช้สิทธวันนี้ครบแล้ว',
    ap_promo_already_used: 'ท่านใช้โปรมั่นชั่นนี้ไปแล้ว',
    ap_processing_please_wait: 'โปรดรอซักครุ่กำลังดำเนินการ',
    ap_enter_gift_link_min10: 'โปรดใส่ลิ้งค์ ของขวัญด้านล่าง ขั้นต่ำ 10 บาท',
    ap_truemoney_topup_success: 'เติมเงินสำเร็จจำนวน ',
    ap_gift_link_used: 'ลิ้งค์ของขวัญถูกใช้งานไปแล้วไม่สามารถไช้ได้',
    ap_gift_link_not_yours: 'ลิงค์เติมเงิน ไม่ใช่ชื่อบัญชีของคุณ โปรดตรวจสอบ',
    ap_truemoney_closed: 'ปิดระบบเติมเงินทรู รออัพเดท',
    ap_gift_link_failed: 'ทำรายการไม่สำเร็จหรือลิงค์ไม่สามารถใช้ได้ ',
    ap_no_gift_link: 'คุณไม่ได้ไส่ลิ้งค์ของขวัญ ',
    ap_processing_please_wait2: 'กำลังดำเนินการโปรดรอซักครู่',
    ap_scan_qr_within_5min: 'กรุณาสแกน qrcode ภายใน 5 นาที',
    ap_min_deposit_prefix: 'เติมขั้นต่ำ ',
    ap_max_deposit_mid: ' บาท สูงสุด ',
    ap_claim_rank_question: 'คุณต้องการเคลม Rank หรือ ไม่?',
    ap_action_done: 'ดำเนินการเรียบร้อย',
    ap_action_failed_wait: 'ไม่สามารถดำเนินการได้ โปรดรอซักครู่',
    ap_received_money_done: 'ทำรายการรับเงินเรียบร้อย',
    ap_no_balance: 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน',
    ap_action_failed: 'ไม่สามารถทำรายการได้',
    ap_password_changed: 'เปลี่ยนพาสเวิดเรียบร้อย',
    ap_old_password_wrong: 'คุณใส่รหัสเก่าผิดพลาด',
    ap_error_try_again: 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง',
    ap_same_password: 'คุณใช้พาสเวิดเดิม',
    ap_password_mismatch: 'คุณใส่พาสเวิดไม่ตรงกัน',
    ap_phone_invalid: 'คุณใส่เบอร์ผิดพลาด',
    ap_phone_in_use: 'เบอร์นี้มีคนใช้แล้ว',
    ap_too_frequent: 'คุณทำรายการถี่เกินไป โปรดรอซักครู่',
    ap_select_bank_or_complete: 'กรุณาเลือกธนาคาร หรือใส่ข้อมูลให้ครบถ้วน !!',
    ap_otp_incomplete: 'คุณใส่ตัวเลขไม่ครบ',
    ap_otp_wrong: 'รหัสผิดพลาด',
    ap_phone_not_found: 'ไม่มีเบอร์นี้ในระบบ',
    ap_withdraw_done: 'รายการถอนเรียบร้อย',
    ap_withdraw_partial_prefix: 'ทำรายการสำเร็จ คุณสามารถถอนได้ไม่เกิน ',
    ap_withdraw_partial_suffix: ' บาทเนื่องจากคุณรับโบนัส เครดิตส่วนที่เหลือเราจะทำการตัดออก',
    ap_turnover_remaining_prefix: 'ท่านติด Turnover อีก ',
    ap_turnover_remaining_suffix: ' บาท',
    ap_withdraw_problem: 'รายการถอนมีปัญหา โปรดติดต่อพนักงาน',
    ap_min_withdraw_100: 'ขั้นต่ำในการถอน 100 บาท',
    ap_cancel_withdraw_question: 'คุณต้องการยกเลิกการถอนเงินใช่ หรือ ไม่?',
    ap_cancel_promo_question: 'คุณต้องการยกเลิกการใช้โปรใช่ หรือ ไม่?',
    ap_coupon_used_done: 'ดำเนินการใช้คูปองเรียบร้อย',
    ap_coupon_not_found: 'ไม่มี Key นี้ในระบบ',
    ap_force_withdraw_all: 'บังคับถอนยอดทั้งหมด',
    ap_not_login: ' คุณไม่ได้ทำการ Login',
    ap_password_min6: 'Password คุณไม่ครบ 6 ตัวโปรดตรวจสอบ',
    ap_no_phone_input: 'คุณไม่ทำการใส่ เบอร์โทรศัพท์',
    ap_no_account_input: 'คุณไม่ทำการใส่เลขบัญชีธนาคาร',
    ap_no_name_input: 'คุณไม่ทำการใส่ ชื่อ-นามสกุล',
    ap_no_bank_selected: 'คุณยังไม่ได้เลือกธนาคาร',
    ap_register_pass_mismatch: 'คุณไส่พาสเวิดไม่ตรงกัน',
    ap_register_done_login: 'ทำการสมัครเรียบร้อยโปรด Log in อีกครั้ง',
    ap_username_taken: 'Username นี้ทำการสมัครไปแล้ว',
    ap_username_or_name_invalid: 'Username หรือ ชื่อในการสมัครไม่ถูกต้อง',

    // share-earn modal
    ap_share_earn_title: 'แชร์แลกทรัพย์',
    ap_share_earn_alt: 'แชร์ แลก ทรัพย์',
    ap_go_to_page: 'เข้าไปที่เพจ :',
    ap_share_pinned_post: 'และแชร์โพสต์ที่ปักหมุด',
    ap_copy_caption_hashtag: 'คัดลอกแคปชั่น และแฮชแท็กสำหรับใส่ในโพสต์ แต่งคอมเมนต์',
    ap_paste_caption_hashtag: 'พร้อมวางแคปชั่นและแฮชแท็กลงไป',
    ap_fb_public_share: 'หน้าเฟซบุ๊กเปิดสาธารณะ 1 โพสต์ , แชร์ลงกลุ่ม 2 กลุ่ม และ',
    ap_like_page: 'กดไลก์เพจ :',
    ap_copy_each_link: 'พร้อมคัดลอกลิงก์ของแต่ละโพสต์',
    ap_attach_evidence_each: 'เพื่อนำมาแนบไฟล์ส่งเป็นหลักฐาน (โพสต์ละ 1 ลิงก์)',
    ap_share_complete_attach: 'เมื่อแชร์ครบตามเงื่อนไขแล้ว กด "แนบไฟล์เพื่อรับสิทธิ์"',
    ap_to_get_bonus: 'เพื่อรับโบนัส',
    ap_admin_check_next_day: 'แอดมินจะตรวจสอบโพสต์จากลิงก์ในวันถัดไป',
    ap_credit_after_check: 'และเครดิตจะเข้าหลังจากแอดมินตรวจเสร็จทันที',
    ap_no_evidence_forfeit: 'แต่ถ้าไม่พบหลักฐานในลิงก์ถือว่าสละสิทธิ์ ❌',
    ap_real_active_account: 'ต้องเป็นบัญชีจริงที่มีการเคลื่อนไหว และเปิดเป็นโพสต์สาธารณะ',
    ap_for_verification: 'เพื่อการตรวจสอบ',
    ap_fb_friends_300: 'บัญชีเฟซบุ๊กที่ทำแชร์แลกทรัพย์ ต้องมีเพื่อนมากกว่า 300',
    ap_people_more: 'คนขึ้นไป',
    ap_group_public_1000: 'กลุ่มที่ทำการแชร์ต้องเป็นกลุ่มสาธารณะและมีสมาชิกมากกว่า 1,000',
    ap_people_more2: 'คนขึ้นไป',
    ap_limit_1_per_day: 'จำกัดสิทธิ์ 1 บุคคล 1 ครั้งต่อวัน',
    ap_withdraw_share_condition: 'สามารถถอนเครดิตแชร์แลกทรัพย์ได้ ต่อเมื่อฝากครบ 500 บาทขึ้นไป',
    ap_within_14_days: 'ภายใน 14 วัน',
    ap_member_must: 'สมาชิกต้อง',
    ap_open_public_post: 'เปิดเป็นโพสสาธารณะ',
    ap_verify_or_forfeit: 'เพื่อการตรวจสอบ มิเช่นนั้นจะถือว่าสละสิทธิ์',
    ap_copy_caption_comment: 'คัดลอก แคปชั่น แฮชแท็ก สำหรับใส่ในโพส คอมเม้นซะหน่อย',
    ap_paste_caption_hashtag2: 'พร้อมวางแคปชั่นแฮชแท็กลงไป',
    ap_share_now_good: 'กด "แชร์เลย" จะมีสิ่งดีๆ เพื่อแชร์ไปยัง facebook',
    ap_share_now: 'แชร์เลย',
    ap_attach_evidence_get: 'แนบหลักฐาน เพื่อรับสิทธิ์',
    ap_bonus_wait_confirm: 'รับโบนัสและรอยืนยันไม่เกินอดใจ',
    ap_evidence_link1: 'ลิงค์หลักฐาน 1',
    ap_evidence_link2: 'ลิงค์หลักฐาน 2',
    ap_evidence_link3: 'ลิงค์หลักฐาน 3',
    ap_send_evidence: 'ส่งหลักฐาน',
    ap_submit_evidence: 'ส่งหลักฐาน',

    // notification board / login / register
    ap_notify_board: 'กระดานแจ้งเตือน',
    ap_forgot_password_title: 'ลืมรหัสผ่าน',
    ap_forgot_password: 'ลืมรหัสผ่าน',
    ap_phone_registered_placeholder: 'เบอร์โทรศัพท์ที่เคยลงทะเบียน',
    ap_confirm_otp: 'ยืนยัน OTP',
    ap_otp_verify_alt: 'กรอกรหัส OTP เพื่อยืนยันตัวตน',
    ap_otp_4digit_placeholder: 'กรุณากรอก OTP 4 หลัก',
    ap_confirm_password_title: 'กรุณา Confirm Password',
    ap_enter_password_placeholder: 'กรุณารหัสผ่าน',
    ap_found_problem: 'พบปัญหา',
    ap_contact_support: 'ติดต่อฝ่ายบริการลูกค้า',
    ap_notify: 'แจ้งเตือน',
    ap_phone_placeholder: 'เบอร์โทรศัพท์',
    ap_password_placeholder: 'รหัสผ่าน',

    // deposit
    ap_choose_promo_before_topup: 'หน้าเลือกโปรก่อนเติม',
    ap_promo_default_alt: 'บาคาร่า คาสิโน สล็อตออนไลน์ promotion default',
    ap_problem: 'ติดปัญหา',
    ap_min_deposit_100: 'เงินฝากขั้นต่ำ 100',
    ap_min_deposit_10: 'เงินฝากขั้นต่ำ 10',
    ap_bank_prefix: 'ธนาคาร ',
    ap_use_registered_account_only: 'กรุณาใช้เลขบัญชีที่สมัครโอนเข้ามาเท่านั้น',
    ap_if_problem: 'หากพบปัญหา',
    ap_want_promo: 'ต้องการรับโปรโมชั่น',
    ap_min_deposit_dyn_prefix: 'เงินฝากขั้นต่ำ ',
    ap_max_dyn_mid: ' สูงสุด ',
    ap_baht_suffix: ' บาท',
    ap_deposit_truemoney_title: 'ฝากเงินทรูมันนี่',
    ap_enter_gift_link_placeholder: 'ใส่ลิ้งของขวัญ',
    ap_wallet_prefix: 'วอลเลท ',

    // withdraw
    ap_min_withdraw_1: 'เงินถอนขั้นต่ำ 1',
    ap_credit_available: 'เครดิตที่มี',

    // account / profile
    ap_account_info: 'ข้อมูลบัญชี',
    ap_change_password: 'เปลี่ยนรหัสผ่าน',
    ap_current_password_placeholder: 'รหัสผ่านปัจจุบัน',
    ap_new_password_placeholder: 'รหัสผ่านใหม่',
    ap_confirm_placeholder: 'การยืนยัน',
    ap_rank_condition_prefix: 'เงื่อนไขขั้น ',
    ap_deposit_more_prefix: 'ฝากอีก ',
    ap_member_benefit: 'ขั้น Member จะได้รับสิทธิพิเศษและโปรโมชั่นที่ดียิ่งขึ้น',
    ap_account_number_label: 'เลขบัญชี : ',
    ap_account_name_label: 'ชื่อบัญชี : ',
    ap_change_account_contact: '*ต้องการเปลี่ยนบัญชี กรุณา',
    ap_use_coupon: 'ใช้คูปอง',
    ap_coupon_code_placeholder: 'รหัสคูปอง',

    // menu (profile sidebar)
    ap_menu_account_info: 'ข้อมูลบัญชี',
    ap_menu_invite_friend: 'ชวนเพื่อน',
    ap_menu_cashback: 'คืนยอดใด้เสีย',
    ap_menu_history: 'ประวัติ',
    ap_menu_history_full: 'ประวัติทำรายการ',
    ap_menu_use_coupon: 'ใช้คูปอง',
    ap_menu_joined_promo: 'โปรโมชั่นที่เข้าร่วม',
    ap_menu_logout: 'ออกจากระบบ',
    ap_logout_confirm_title: 'ต้องการออกจากระบบ ?',
    ap_menu_cashback2: 'รับคืนยอดเสีย',

    // cashback
    ap_get_cashback_bonus_prefix: 'รับโบนัสยอดเสีย ',
    ap_bonus_amount_period: 'ยอดโบนัสระหว่างวันที่ ',
    ap_get_loss: 'รับยอดเสีย',
    ap_not_eligible: 'ไม่เข้าเงื่อนไข',
    ap_you_got_loss_prefix: 'คุณได้รับยอดเสีย ',
    ap_not_eligible_bonus: 'คุณไม่เข้าเงื่อนไขการรับโบนัส',
    ap_read_condition_join: 'โปรดอ่านเงื่อนไขการเข้าร่วม',
    ap_below: 'ด้านล่างค่ะ',
    ap_read_condition: 'โปรดอ่านเงื่อนไข',
    ap_get_rank_bonus: 'ขอรับโบนัส Rank',
    ap_success: 'สำเร็จ',
    ap_not_passed_condition: 'ยังไม่ผ่านเงื่อนไข',

    // history / status
    ap_history_title: 'ประวัติการทำรายการ',
    ap_bonus_special: '*โบนัสพิเศษ',
    ap_status_label: 'สถานะ : ',
    ap_status_processing: 'กำลังดำเนินการ',
    ap_status_pending: 'รอดำเนินการ',
    ap_status_cancel_by_player: 'ยกเลิก (ยกเลิกโดยผู้เล่น)',
    ap_status_cancel_by_player_short: 'ยกเลิก (โดยผู้เล่น)',
    ap_status_fail_by_system: 'ไม่สำเร็จ (โดยระบบ)',
    ap_status_success: 'สำเร็จ',

    // affiliate
    ap_invite_friend_title: 'ชวนเพื่อน',
    ap_get_invite_link: 'รับลิงค์ชวนเพื่อน',
    ap_click_link: 'กดที่ลิงค์ ',
    ap_name_list: 'รายชื่อที่มี',
    ap_complete_min_deposit_100: 'ครบเงื่อนใขการเติมเงินขั่นต่ำ 100 บาทแล้ว ',
    ap_you_got_invite_credit: 'คุณได้รับเครดิตชวนเพื่อน',
    ap_calc_every_sunday: 'บาท (คำนวณทุกวันอาทิตย์ เวลา 00.00น.)',
    ap_you_got_percent: 'คุณได้เปอเซนต์  ',
    ap_from_loss_received: ' จากยอดเสีย ยอดได้รับ ',

    // cashback page
    ap_cashback_title: 'คืนยอดได้เสีย',
    ap_cashback_condition: 'เงื่อนใข รับยอดได้เสีย  ',
    ap_you_got_cashback: 'คุณได้รับคืนยอดเสียจำนวน ',
    ap_give_invite_credit: 'ให้เครดิตชวนเพื่อน',
    ap_give_first_deposit_credit: 'ให้เครดิตเติมครั้งแรก',
    ap_calc_every_sunday2: ' (คำนวณทุกวันอาทิตย์.)',

    // joined promo
    ap_joined_promo: 'โปรโมชั่นที่เข้าร่วม',
    ap_get_bonus_not_open: 'ขอรับโบนัส (ยังไม่เปิดใช้โปรโมชั่นนี้)',
    ap_promo_not_open: 'ยังไม่เปิดใช้โปรโมชั่นนี้',
    ap_promo_rank_more: 'โปรโมชั่นเพิ่ม Rank ',

    // promo detail
    ap_promotion: 'โปรโมชั่น',
    ap_promo_not_active: 'โปรโมชั่นยังไม่ได้เปิดใช้งาน',
    ap_get_promo: 'รับโปรโมชั่น',

    // notice board items
    ap_bank_down: 'ขณะนี้ธนาคารขัดข้อง',
    ap_sorry_inconvenience: 'ขออภัยในความไม่สะดวกค่ะ',
    ap_2_months_ago: '2 เดือนที่แล้ว',
    ap_invite_more_get_more: 'ยิ่งชวนยิ่งได้',
    ap_invite_friend_play: 'แนะนำเพื่อนมาเล่น รับสูงสุด 300 บาท ชวนครบ 10 คน',
    ap_get_extra_1000: 'รับเพิ่มทันทีอีก 1000 บาท',
    ap_contact_service: 'สอบถามเพิ่มเติมได้ที่ฝ่ายบริการ @betsup',
    ap_3_months_ago: '3 เดือนที่แล้ว',
    ap_delete_all: 'ลบทั้งหมด',

    // enter game / bookmark
    ap_enter_game: 'เข้าสู่เกม',
    ap_chrome_step1a: 'เข้า Google Chrome แล้ว',
    ap_chrome_step1b: 'Search "Label" เข้าสู่หน้าเว็บ',
    ap_chrome_step2a: 'กดที่ ',
    ap_chrome_step2b: 'เลือก "เพิ่มลงในหน้าจอหลัก"',
    ap_chrome_step3a: 'กด "เพิ่ม" ทางลัดเข้าสู่เกมส์',
    ap_chrome_step3b: 'ลงในหน้าจอโฮม',
    ap_chrome_step4a: 'ตรวจสอบหน้า',
    ap_chrome_step4b: 'โฮมสกรีนว่ามีไอคอนขึ้นแล้ว',

    // footer / brand
    ap_baccarat: 'บาคาร่า',
    ap_casino: 'คาสิโน',
    ap_wheel: 'กงล้อ',

    // first deposit / payment
    ap_promo_available: 'โปรโมชั่นที่รับได้',
    ap_cancel_promo: 'ยกเลิกโปรโมชั่น',
    ap_receive_promo: 'รับโปรโมชั่น',
    ap_balance_remaining: 'เงินคงเหลือ',
    ap_turnover_label: 'เทิร์นโอเวอร์ ',
    ap_transfer_within: 'กรุณาโอนภายใน : ',
    ap_5_minutes: ' 5 นาที',
    ap_no_promo_text: 'ไม่รับโปรโมชั่น',
    ap_after_transfer_press: 'เมื่อโอนแล้ว อย่าลืมกด ',
    ap_below_here: ' ด้านล่างนี้นะคะ',
    ap_edit_deposit_confirm: 'ต้องการแก้ไขยอดฝาก ?',
    ap_upload_slip: 'อัปโหลดสลิป',
    ap_slip_max_5mb: 'รูปจะต้องมีขนาดไม่เกิน 5MB',
    ap_slip_required_note: '**จำเป็น** ห้ามถ่ายรูปจากหน้าจออื่น ',
    ap_slip_qr_clear: 'ในสลิปชัดเจน',
    ap_and_must_see_qr: ' และ ต้องเห็น QRCode',

    // navbar extra
    ap_toprank: 'จัดอันดับ',
    ap_strategy: 'กลยุทธ์',
    ap_invite_friend_nav: 'ชวนเพื่อน',
    ap_join_promo: 'การเข้าร่วมโปรโมชั่น',
    ap_you_got_loss_credit: 'คุณได้รับเครดิตยอดเสีย',

    // ===== ap2_ : remaining prose / T&C / SEO / share blocks =====
    // news ticker
    ap2_ticker_main: 'Ae sexyคาสิโนออนไลน์ สล็อตออนไลน์ ที่ให้คุณสนุกได้ทุกรูปแบบ',
    // footer SEO title/content
    ap2_footer_title_a: 'Ae sexyCASINO th เว็บคาสิโนออนไลน์ ',
    ap2_footer_title_b: 'ครองอันดับในใจคนไทย 3 ปีซ้อน',
    ap2_footer_content: 'Ae sexyCasino บาคาร่า คาสิโนออนไลน์ ที่ดีที่สุด เพื่อประสบการณ์ที่ดีของผู้เล่นอย่างแท้จริง แบบAe sexyCasino',
    // footer tags (brand words kept, Thai translated)
    ap2_tag_casino: 'Ae sexyคาสิโน',
    ap2_tag_casino_online: 'Ae sexyคาสิโนออนไลน์',
    ap2_tag_baccarat: 'Ae sexyบาคาร่า',
    ap2_tag_live_casino: 'คาสิโนสด',
    // social share caption
    ap2_share_copied_msg: 'คัดลอกแล้ว',
    ap2_share_caption: `🌎 AE Sexy อันดับหนึ่งที่คุณต้องสัมผัส
🔥 สมาชิกใหม่ 100 รับ 150
🔥 สมาชิกใหม่ 300 รับ 500
🔥 สมาชิกใหม่รับโบนัส 50% สูงสุด 1,000
🔥 โปรร้อนแรง ฝาก 1000 ฟรี 100 ไม่ติดเงื่อนไข
🔥 เล่นได้ให้เพิ่ม เล่นเสียคืนให้ 5% ทุกวันเสาร์ รับได้ตลอดชีพ
🎁 ฝาก - ถอน 3 วิ. ด้วยระบบ AI ที่ใช้ได้จริงเจ้าเดียวในไทย

#แชร์แลกทรัพย์ #รับได้ทุกวัน #ทำได้ทุกคน #ทำง่ายไม่กี่ขั้นตอน #เว็บดีโปรแรง #อันดับหนึ่ง #aesexy #ฝากถอนไวสุด
#aeที่ดีที่สุด`,
    // promo T&C heading + bullets (weekly cashback)
    ap2_tc_play_more_lose_back_prefix: 'เล่นได้ให้เพิ่ม เล่นเสียให้คืน ',
    ap2_tc_play_more_lose_back_suffix: ' % ทุกสัปดาห์',
    ap2_tc_play_more_lose_back_5: 'เล่นได้ให้เพิ่ม เล่นเสียให้คืน 5% ทุกสัปดาห์',
    ap2_tc_calc_week_mon: '► คำนวณยอดใน 1 สัปดาห์ (ตั้งแต่ จันทร์ 00:01 น. ถึง วันอาทิตย์ 23:59 น.)',
    ap2_tc_calc_week_sat: '► คำนวณยอดใน 1 สัปดาห์ (ตั้งแต่ เสาร์ 00:01 น. ถึง วันศุกร์ 23:59 น.)',
    ap2_tc_turnover_5x: '► ต้องมียอดเทิร์นโอเวอร์ 5 เท่าของเงินฝากภายในสัปดาห์',
    ap2_tc_bonus_every_mon: '► โบนัสจะได้รับทุกวันจันทร์ สามารถกดรับโบนัสได้ที่หน้าเว็บ',
    ap2_tc_bonus_every_sat: '► โบนัสจะได้รับทุกวันเสาร์ สามารถกดรับโบนัสได้ที่หน้าเว็บ',
    ap2_tc_bonus_no_turnover: '► โบนัสที่ได้รับไม่ต้องทำเทิร์นโอเวอร์ ถอนได้ทันที!',
    ap2_tc_min_winloss_500: '► มียอดได้-เสียมากกว่า 500 บาทต่อสัปดาห์ จึงจะได้รับโบนัส 5%',
    ap2_tc_min_winloss_2000: '► มียอดได้-เสียมากกว่า 2000 บาทต่อสัปดาห์ จึงจะได้รับโบนัส 5%',
    ap2_tc_credit_expire_7: '► เมื่อรับโปรโมชั่น เครดิตจะมีอายุการใช้งาน 7 วัน จากนั้นเครดิตคืนยอดเสียจะถูกปรับเป็น 0',
    ap2_tc_credit_expire_3: '► เมื่อรับโปรโมชั่น เครดิตจะมีอายุการใช้งาน 3 วัน จากนั้นเครดิตคืนยอดเสียจะถูกปรับเป็น 0',
    ap2_tc_basic_rules: 'เงื่อนไขและกติกาพื้นฐานจะถูกนำมาใช้กับโปรโมชั่นนี้',
    // promo-tier description spans
    ap2_topup_word: 'เติม',
    ap2_topup_word_baht: ' บาท ',
    ap2_topup_word_baht_more: ' บาทขึ้นไป ',
    ap2_bonus_word: 'โบนัส ',
    ap2_bonus_baht_invite: ' บาท ชวนเพื่อน ',
    ap2_bonus_baht_only: ' บาท',
    // moment date Thai time suffix
    ap2_time_suffix: 'น.',
    // short month names (for cashback period display)
    ap2_months_mini: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
  },
  en: {
    ap_ok: 'OK',
    ap_confirm: 'Confirm',
    ap_cancel: 'Cancel',
    ap_back: 'Back',
    ap_back2: 'Back',
    ap_next: 'Next',
    ap_copy: 'Copy',
    ap_copied: 'Copied',
    ap_copied_excl: 'Copied!',
    ap_acknowledge: 'Acknowledge',
    ap_done: 'Done',
    ap_claim: 'Claim',
    ap_baht: 'Baht',
    ap_credit_unit: 'Credit',
    ap_login: 'Login',
    ap_register: 'Register',
    ap_register_now: 'Register now',
    ap_login_short: 'Login',
    ap_deposit: 'Deposit',
    ap_withdraw: 'Withdraw',
    ap_topup: 'Top up',
    ap_topup_payment: 'Top up Payment',
    ap_no_data: 'No data found',
    ap_no_history: 'You have no transaction history yet.',
    ap_no_affiliate: 'You have no referral data yet.',
    ap_no_cashback: 'You have no cashback records.',

    ap_withdraw_insufficient: 'Your withdrawal balance is insufficient.',
    ap_session_expired: 'Your session has expired. Please log in again.',
    ap_promo_pending_can_topup: 'You have a pending promotion. You can top up now.',
    ap_promo_received: 'Promotion received successfully.',
    ap_promo_not_eligible: 'You do not meet the conditions for this promotion.',
    ap_quota_used_today: 'You have used up your quota for today.',
    ap_promo_already_used: 'You have already used this promotion.',
    ap_processing_please_wait: 'Please wait, processing in progress.',
    ap_enter_gift_link_min10: 'Please enter the gift link below, minimum 10 Baht.',
    ap_truemoney_topup_success: 'Top up successful, amount ',
    ap_gift_link_used: 'This gift link has already been used and cannot be used again.',
    ap_gift_link_not_yours: 'The top-up link is not under your account name. Please check.',
    ap_truemoney_closed: 'TrueMoney top-up is closed, awaiting update.',
    ap_gift_link_failed: 'Transaction failed or the link cannot be used. ',
    ap_no_gift_link: 'You did not enter a gift link. ',
    ap_processing_please_wait2: 'Processing, please wait a moment.',
    ap_scan_qr_within_5min: 'Please scan the QR code within 5 minutes.',
    ap_min_deposit_prefix: 'Minimum deposit ',
    ap_max_deposit_mid: ' Baht, maximum ',
    ap_claim_rank_question: 'Do you want to claim Rank?',
    ap_action_done: 'Action completed.',
    ap_action_failed_wait: 'Unable to proceed. Please wait a moment.',
    ap_received_money_done: 'Money received successfully.',
    ap_no_balance: 'Unable to proceed, no balance available.',
    ap_action_failed: 'Unable to proceed.',
    ap_password_changed: 'Password changed successfully.',
    ap_old_password_wrong: 'You entered the wrong old password.',
    ap_error_try_again: 'An error occurred. Please try again.',
    ap_same_password: 'You used the same password.',
    ap_password_mismatch: 'Your passwords do not match.',
    ap_phone_invalid: 'You entered an invalid phone number.',
    ap_phone_in_use: 'This phone number is already in use.',
    ap_too_frequent: 'You are making requests too frequently. Please wait a moment.',
    ap_select_bank_or_complete: 'Please select a bank or fill in all information!!',
    ap_otp_incomplete: 'You did not enter all the digits.',
    ap_otp_wrong: 'Incorrect code.',
    ap_phone_not_found: 'This phone number is not in the system.',
    ap_withdraw_done: 'Withdrawal completed.',
    ap_withdraw_partial_prefix: 'Transaction successful. You can withdraw up to ',
    ap_withdraw_partial_suffix: ' Baht because you received a bonus. The remaining credit will be deducted.',
    ap_turnover_remaining_prefix: 'You still have a Turnover of ',
    ap_turnover_remaining_suffix: ' Baht.',
    ap_withdraw_problem: 'There is a problem with the withdrawal. Please contact staff.',
    ap_min_withdraw_100: 'Minimum withdrawal is 100 Baht.',
    ap_cancel_withdraw_question: 'Do you want to cancel the withdrawal?',
    ap_cancel_promo_question: 'Do you want to cancel the promotion?',
    ap_coupon_used_done: 'Coupon used successfully.',
    ap_coupon_not_found: 'This Key is not in the system.',
    ap_force_withdraw_all: 'Force withdraw entire balance.',
    ap_not_login: ' You are not logged in',
    ap_password_min6: 'Your password is less than 6 characters. Please check.',
    ap_no_phone_input: 'You did not enter a phone number.',
    ap_no_account_input: 'You did not enter a bank account number.',
    ap_no_name_input: 'You did not enter your full name.',
    ap_no_bank_selected: 'You have not selected a bank.',
    ap_register_pass_mismatch: 'Your passwords do not match.',
    ap_register_done_login: 'Registration complete. Please log in again.',
    ap_username_taken: 'This Username has already been registered.',
    ap_username_or_name_invalid: 'Username or registration name is incorrect.',

    ap_share_earn_title: 'Share to Earn',
    ap_share_earn_alt: 'Share to Earn',
    ap_go_to_page: 'Go to the page:',
    ap_share_pinned_post: 'and share the pinned post',
    ap_copy_caption_hashtag: 'Copy the caption and hashtags to put in the post, write a comment',
    ap_paste_caption_hashtag: 'and paste the caption and hashtags in',
    ap_fb_public_share: 'Facebook page set public, 1 post, share to 2 groups, and',
    ap_like_page: 'Like the page:',
    ap_copy_each_link: 'and copy the link of each post',
    ap_attach_evidence_each: 'to attach as evidence (1 link per post)',
    ap_share_complete_attach: 'Once you complete the sharing conditions, press "Attach file to claim"',
    ap_to_get_bonus: 'to receive the bonus',
    ap_admin_check_next_day: 'The admin will check the posts from the links the next day',
    ap_credit_after_check: 'and the credit will be added right after the admin finishes checking',
    ap_no_evidence_forfeit: 'But if no evidence is found in the link, it is considered forfeited ❌',
    ap_real_active_account: 'Must be a real active account, and set as a public post',
    ap_for_verification: 'for verification',
    ap_fb_friends_300: 'The Facebook account doing the share-to-earn must have more than 300',
    ap_people_more: 'friends or more',
    ap_group_public_1000: 'The group shared to must be a public group with more than 1,000',
    ap_people_more2: 'members or more',
    ap_limit_1_per_day: 'Limited to 1 person, 1 time per day',
    ap_withdraw_share_condition: 'Share-to-earn credit can be withdrawn only after depositing 500 Baht or more',
    ap_within_14_days: 'within 14 days',
    ap_member_must: 'Members must',
    ap_open_public_post: 'set it as a public post',
    ap_verify_or_forfeit: 'for verification, otherwise it will be considered forfeited',
    ap_copy_caption_comment: 'Copy the caption and hashtags for the post and comment',
    ap_paste_caption_hashtag2: 'and paste the caption and hashtags in',
    ap_share_now_good: 'Press "Share now" for good things to share to facebook',
    ap_share_now: 'Share now',
    ap_attach_evidence_get: 'Attach evidence to claim',
    ap_bonus_wait_confirm: 'Receive the bonus and wait for confirmation soon',
    ap_evidence_link1: 'Evidence link 1',
    ap_evidence_link2: 'Evidence link 2',
    ap_evidence_link3: 'Evidence link 3',
    ap_send_evidence: 'Send evidence',
    ap_submit_evidence: 'Submit evidence',

    ap_notify_board: 'Notification Board',
    ap_forgot_password_title: 'Forgot Password',
    ap_forgot_password: 'Forgot Password',
    ap_phone_registered_placeholder: 'Previously registered phone number',
    ap_confirm_otp: 'Confirm OTP',
    ap_otp_verify_alt: 'Enter OTP code to verify identity',
    ap_otp_4digit_placeholder: 'Please enter the 4-digit OTP',
    ap_confirm_password_title: 'Please Confirm Password',
    ap_enter_password_placeholder: 'Please enter password',
    ap_found_problem: 'Found a problem',
    ap_contact_support: 'Contact Customer Service',
    ap_notify: 'Notification',
    ap_phone_placeholder: 'Phone number',
    ap_password_placeholder: 'Password',

    ap_choose_promo_before_topup: 'Choose promotion before topping up',
    ap_promo_default_alt: 'baccarat casino slot online promotion default',
    ap_problem: 'Problem',
    ap_min_deposit_100: 'Minimum deposit 100',
    ap_min_deposit_10: 'Minimum deposit 10',
    ap_bank_prefix: 'Bank ',
    ap_use_registered_account_only: 'Please transfer only from the account you registered with.',
    ap_if_problem: 'If you have a problem',
    ap_want_promo: 'Want to receive a promotion',
    ap_min_deposit_dyn_prefix: 'Minimum deposit ',
    ap_max_dyn_mid: ' maximum ',
    ap_baht_suffix: ' Baht',
    ap_deposit_truemoney_title: 'Deposit TrueMoney',
    ap_enter_gift_link_placeholder: 'Enter gift link',
    ap_wallet_prefix: 'Wallet ',

    ap_min_withdraw_1: 'Minimum withdrawal 1',
    ap_credit_available: 'Available credit',

    ap_account_info: 'Account Information',
    ap_change_password: 'Change Password',
    ap_current_password_placeholder: 'Current password',
    ap_new_password_placeholder: 'New password',
    ap_confirm_placeholder: 'Confirmation',
    ap_rank_condition_prefix: 'Condition for tier ',
    ap_deposit_more_prefix: 'Deposit ',
    ap_member_benefit: 'The Member tier receives special privileges and better promotions.',
    ap_account_number_label: 'Account number: ',
    ap_account_name_label: 'Account name: ',
    ap_change_account_contact: '*To change your account, please',
    ap_use_coupon: 'Use Coupon',
    ap_coupon_code_placeholder: 'Coupon code',

    ap_menu_account_info: 'Account Information',
    ap_menu_invite_friend: 'Invite Friends',
    ap_menu_cashback: 'Loss Cashback',
    ap_menu_history: 'History',
    ap_menu_history_full: 'Transaction History',
    ap_menu_use_coupon: 'Use Coupon',
    ap_menu_joined_promo: 'Joined Promotions',
    ap_menu_logout: 'Logout',
    ap_logout_confirm_title: 'Do you want to log out?',
    ap_menu_cashback2: 'Get Loss Cashback',

    ap_get_cashback_bonus_prefix: 'Get loss bonus ',
    ap_bonus_amount_period: 'Bonus amount during the period ',
    ap_get_loss: 'Get loss',
    ap_not_eligible: 'Not eligible',
    ap_you_got_loss_prefix: 'You received a loss bonus of ',
    ap_not_eligible_bonus: 'You are not eligible for the bonus.',
    ap_read_condition_join: 'Please read the participation conditions',
    ap_below: 'below.',
    ap_read_condition: 'Please read the conditions',
    ap_get_rank_bonus: 'Claim Rank Bonus',
    ap_success: 'Success',
    ap_not_passed_condition: 'Condition not yet met',

    ap_history_title: 'Transaction History',
    ap_bonus_special: '*Special Bonus',
    ap_status_label: 'Status: ',
    ap_status_processing: 'Processing',
    ap_status_pending: 'Pending',
    ap_status_cancel_by_player: 'Cancelled (cancelled by player)',
    ap_status_cancel_by_player_short: 'Cancelled (by player)',
    ap_status_fail_by_system: 'Failed (by system)',
    ap_status_success: 'Success',

    ap_invite_friend_title: 'Invite Friends',
    ap_get_invite_link: 'Get referral link',
    ap_click_link: 'Click the link ',
    ap_name_list: 'Names that have',
    ap_complete_min_deposit_100: 'met the minimum deposit condition of 100 Baht ',
    ap_you_got_invite_credit: 'You received referral credit',
    ap_calc_every_sunday: 'Baht (calculated every Sunday at 00:00)',
    ap_you_got_percent: 'You got a percentage of  ',
    ap_from_loss_received: ' of the loss, amount received ',

    ap_cashback_title: 'Loss Cashback',
    ap_cashback_condition: 'Condition for receiving loss cashback  ',
    ap_you_got_cashback: 'You received a loss cashback of ',
    ap_give_invite_credit: 'Give referral credit',
    ap_give_first_deposit_credit: 'Give first deposit credit',
    ap_calc_every_sunday2: ' (calculated every Sunday.)',

    ap_joined_promo: 'Joined Promotions',
    ap_get_bonus_not_open: 'Claim bonus (this promotion is not yet open)',
    ap_promo_not_open: 'This promotion is not yet open',
    ap_promo_rank_more: 'Promotion to increase Rank ',

    ap_promotion: 'Promotion',
    ap_promo_not_active: 'Promotion is not active yet',
    ap_get_promo: 'Get promotion',

    ap_bank_down: 'The bank is currently down',
    ap_sorry_inconvenience: 'We apologize for the inconvenience.',
    ap_2_months_ago: '2 months ago',
    ap_invite_more_get_more: 'The more you invite, the more you get',
    ap_invite_friend_play: 'Invite friends to play, get up to 300 Baht, invite 10 people',
    ap_get_extra_1000: 'and get an extra 1000 Baht instantly',
    ap_contact_service: 'For more info, contact our service at @betsup',
    ap_3_months_ago: '3 months ago',
    ap_delete_all: 'Delete all',

    ap_enter_game: 'Enter Game',
    ap_chrome_step1a: 'Open Google Chrome',
    ap_chrome_step1b: 'Search "Label" to go to the website',
    ap_chrome_step2a: 'Tap ',
    ap_chrome_step2b: 'select "Add to Home Screen"',
    ap_chrome_step3a: 'Tap "Add" to add a shortcut to the game',
    ap_chrome_step3b: 'to your home screen',
    ap_chrome_step4a: 'Check the page',
    ap_chrome_step4b: 'on your home screen that the icon has appeared',

    ap_baccarat: 'Baccarat',
    ap_casino: 'Casino',
    ap_wheel: 'Wheel',

    ap_promo_available: 'Available Promotions',
    ap_cancel_promo: 'Cancel Promotion',
    ap_receive_promo: 'Receive Promotion',
    ap_balance_remaining: 'Remaining Balance',
    ap_turnover_label: 'Turnover ',
    ap_transfer_within: 'Please transfer within: ',
    ap_5_minutes: ' 5 minutes',
    ap_no_promo_text: 'No promotion',
    ap_after_transfer_press: 'After transferring, do not forget to press ',
    ap_below_here: ' below.',
    ap_edit_deposit_confirm: 'Do you want to edit the deposit amount?',
    ap_upload_slip: 'Upload Slip',
    ap_slip_max_5mb: 'The image must not exceed 5MB',
    ap_slip_required_note: '**Required** Do not photograph from another screen ',
    ap_slip_qr_clear: 'clearly in the slip',
    ap_and_must_see_qr: ' and the QRCode must be visible',

    ap_toprank: 'Top Rank',
    ap_strategy: 'Strategy',
    ap_invite_friend_nav: 'Invite Friends',
    ap_join_promo: 'Promotion Participation',
    ap_you_got_loss_credit: 'You received loss credit',

    // ===== ap2_ =====
    ap2_ticker_main: 'Ae sexy online casino and online slots that let you enjoy every style of play',
    ap2_footer_title_a: 'Ae sexyCASINO th online casino website ',
    ap2_footer_title_b: 'ranked first in Thai hearts for 3 years running',
    ap2_footer_content: 'Ae sexyCasino, the best baccarat and online casino, for a truly great player experience, the Ae sexyCasino way',
    ap2_tag_casino: 'Ae sexy casino',
    ap2_tag_casino_online: 'Ae sexy online casino',
    ap2_tag_baccarat: 'Ae sexy baccarat',
    ap2_tag_live_casino: 'live casino',
    ap2_share_copied_msg: 'Copied',
    ap2_share_caption: `🌎 AE Sexy, the number one you have to experience
🔥 New member 100 get 150
🔥 New member 300 get 500
🔥 New members get a 50% bonus up to 1,000
🔥 Hot promo: deposit 1000 get 100 free with no conditions
🔥 Win and get more, lose and get 5% back every Saturday, claimable for life
🎁 Deposit - withdraw in 3 sec with real working AI, the only one in Thailand

#ShareToEarn #ClaimDaily #AnyoneCanDo #EasyFewSteps #GreatSiteHotPromos #NumberOne #aesexy #FastestDepositWithdraw
#TheBestAe`,
    ap2_tc_play_more_lose_back_prefix: 'Win and get more, lose and get back ',
    ap2_tc_play_more_lose_back_suffix: ' % every week',
    ap2_tc_play_more_lose_back_5: 'Win and get more, lose and get back 5% every week',
    ap2_tc_calc_week_mon: '► Calculated over 1 week (from Monday 00:01 to Sunday 23:59)',
    ap2_tc_calc_week_sat: '► Calculated over 1 week (from Saturday 00:01 to Friday 23:59)',
    ap2_tc_turnover_5x: '► Must have turnover of 5 times the deposit within the week',
    ap2_tc_bonus_every_mon: '► The bonus is granted every Monday, claimable on the website',
    ap2_tc_bonus_every_sat: '► The bonus is granted every Saturday, claimable on the website',
    ap2_tc_bonus_no_turnover: '► The bonus received requires no turnover and can be withdrawn immediately!',
    ap2_tc_min_winloss_500: '► You must have win-loss of more than 500 Baht per week to receive the 5% bonus',
    ap2_tc_min_winloss_2000: '► You must have win-loss of more than 2000 Baht per week to receive the 5% bonus',
    ap2_tc_credit_expire_7: '► Once the promotion is received, the credit is valid for 7 days, after which the loss-cashback credit is reset to 0',
    ap2_tc_credit_expire_3: '► Once the promotion is received, the credit is valid for 3 days, after which the loss-cashback credit is reset to 0',
    ap2_tc_basic_rules: 'Basic terms and conditions will apply to this promotion',
    ap2_topup_word: 'Deposit',
    ap2_topup_word_baht: ' Baht ',
    ap2_topup_word_baht_more: ' Baht or more ',
    ap2_bonus_word: 'Bonus ',
    ap2_bonus_baht_invite: ' Baht, invite friends ',
    ap2_bonus_baht_only: ' Baht',
    ap2_time_suffix: 'hrs',
    ap2_months_mini: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  },
  zh: {
    ap_ok: '确定',
    ap_confirm: '确认',
    ap_cancel: '取消',
    ap_back: '返回',
    ap_back2: '返回',
    ap_next: '下一步',
    ap_copy: '复制',
    ap_copied: '已复制',
    ap_copied_excl: '已复制！',
    ap_acknowledge: '知道了',
    ap_done: '完成',
    ap_claim: '领取',
    ap_baht: '泰铢',
    ap_credit_unit: '积分',
    ap_login: '登录',
    ap_register: '注册',
    ap_register_now: '立即注册',
    ap_login_short: '登录',
    ap_deposit: '存款',
    ap_withdraw: '提款',
    ap_topup: '充值',
    ap_topup_payment: '充值 Payment',
    ap_no_data: '未找到数据',
    ap_no_history: '您还没有交易记录。',
    ap_no_affiliate: '您还没有邀请好友记录。',
    ap_no_cashback: '您还没有返现记录。',

    ap_withdraw_insufficient: '您的提款余额不足。',
    ap_session_expired: '您的会话已过期，请重新登录。',
    ap_promo_pending_can_topup: '您有待处理的优惠，可以直接充值。',
    ap_promo_received: '优惠领取成功。',
    ap_promo_not_eligible: '您不符合此优惠的条件。',
    ap_quota_used_today: '您今天的次数已用完。',
    ap_promo_already_used: '您已经使用过此优惠。',
    ap_processing_please_wait: '请稍候，正在处理中。',
    ap_enter_gift_link_min10: '请在下方输入礼物链接，最低 10 泰铢。',
    ap_truemoney_topup_success: '充值成功，金额 ',
    ap_gift_link_used: '此礼物链接已被使用，无法再次使用。',
    ap_gift_link_not_yours: '充值链接不是您账户的名称，请检查。',
    ap_truemoney_closed: 'TrueMoney 充值已关闭，等待更新。',
    ap_gift_link_failed: '交易失败或链接无法使用。 ',
    ap_no_gift_link: '您没有输入礼物链接。 ',
    ap_processing_please_wait2: '正在处理，请稍候。',
    ap_scan_qr_within_5min: '请在 5 分钟内扫描二维码。',
    ap_min_deposit_prefix: '最低充值 ',
    ap_max_deposit_mid: ' 泰铢，最高 ',
    ap_claim_rank_question: '您要领取 Rank 吗？',
    ap_action_done: '操作完成。',
    ap_action_failed_wait: '无法操作，请稍候。',
    ap_received_money_done: '收款成功。',
    ap_no_balance: '无法操作，没有余额。',
    ap_action_failed: '无法操作。',
    ap_password_changed: '密码修改成功。',
    ap_old_password_wrong: '您输入的旧密码错误。',
    ap_error_try_again: '发生错误，请重试。',
    ap_same_password: '您使用了相同的密码。',
    ap_password_mismatch: '您输入的密码不一致。',
    ap_phone_invalid: '您输入的手机号码有误。',
    ap_phone_in_use: '此手机号码已被使用。',
    ap_too_frequent: '您操作太频繁，请稍候。',
    ap_select_bank_or_complete: '请选择银行或填写完整信息！！',
    ap_otp_incomplete: '您输入的数字不完整。',
    ap_otp_wrong: '验证码错误。',
    ap_phone_not_found: '系统中没有此手机号码。',
    ap_withdraw_done: '提款完成。',
    ap_withdraw_partial_prefix: '操作成功。您最多可提款 ',
    ap_withdraw_partial_suffix: ' 泰铢，因为您领取了奖金，剩余部分将被扣除。',
    ap_turnover_remaining_prefix: '您还有 Turnover ',
    ap_turnover_remaining_suffix: ' 泰铢。',
    ap_withdraw_problem: '提款出现问题，请联系工作人员。',
    ap_min_withdraw_100: '最低提款 100 泰铢。',
    ap_cancel_withdraw_question: '您要取消提款吗？',
    ap_cancel_promo_question: '您要取消使用优惠吗？',
    ap_coupon_used_done: '优惠券使用成功。',
    ap_coupon_not_found: '系统中没有此 Key。',
    ap_force_withdraw_all: '强制提取全部余额。',
    ap_not_login: ' 您尚未登录',
    ap_password_min6: '您的密码不足 6 位，请检查。',
    ap_no_phone_input: '您未输入手机号码。',
    ap_no_account_input: '您未输入银行账号。',
    ap_no_name_input: '您未输入姓名。',
    ap_no_bank_selected: '您还没有选择银行。',
    ap_register_pass_mismatch: '您输入的密码不一致。',
    ap_register_done_login: '注册完成，请重新登录。',
    ap_username_taken: '此用户名已被注册。',
    ap_username_or_name_invalid: '用户名或注册姓名不正确。',

    ap_share_earn_title: '分享赚取',
    ap_share_earn_alt: '分享赚取',
    ap_go_to_page: '前往页面：',
    ap_share_pinned_post: '并分享置顶帖子',
    ap_copy_caption_hashtag: '复制标题和话题标签放入帖子，写评论',
    ap_paste_caption_hashtag: '并粘贴标题和话题标签',
    ap_fb_public_share: 'Facebook 页面设为公开，1 个帖子，分享到 2 个群组，以及',
    ap_like_page: '为页面点赞：',
    ap_copy_each_link: '并复制每个帖子的链接',
    ap_attach_evidence_each: '以附上作为证据（每个帖子 1 个链接）',
    ap_share_complete_attach: '完成分享条件后，点击"附上文件以领取权益"',
    ap_to_get_bonus: '以领取奖金',
    ap_admin_check_next_day: '管理员将在次日通过链接检查帖子',
    ap_credit_after_check: '管理员检查完成后将立即添加积分',
    ap_no_evidence_forfeit: '但如果链接中找不到证据，则视为放弃 ❌',
    ap_real_active_account: '必须是有活动的真实账户，并设为公开帖子',
    ap_for_verification: '以供核实',
    ap_fb_friends_300: '进行分享赚取的 Facebook 账户必须有超过 300',
    ap_people_more: '位好友以上',
    ap_group_public_1000: '分享到的群组必须是公开群组，成员超过 1,000',
    ap_people_more2: '人以上',
    ap_limit_1_per_day: '限每人每天 1 次',
    ap_withdraw_share_condition: '分享赚取积分需在存款满 500 泰铢以上后方可提款',
    ap_within_14_days: '在 14 天内',
    ap_member_must: '会员必须',
    ap_open_public_post: '设为公开帖子',
    ap_verify_or_forfeit: '以供核实，否则将视为放弃',
    ap_copy_caption_comment: '复制标题、话题标签用于帖子和评论',
    ap_paste_caption_hashtag2: '并粘贴标题和话题标签',
    ap_share_now_good: '点击"立即分享"会有好东西分享到 facebook',
    ap_share_now: '立即分享',
    ap_attach_evidence_get: '附上证据以领取权益',
    ap_bonus_wait_confirm: '领取奖金并稍候确认',
    ap_evidence_link1: '证据链接 1',
    ap_evidence_link2: '证据链接 2',
    ap_evidence_link3: '证据链接 3',
    ap_send_evidence: '发送证据',
    ap_submit_evidence: '提交证据',

    ap_notify_board: '通知栏',
    ap_forgot_password_title: '忘记密码',
    ap_forgot_password: '忘记密码',
    ap_phone_registered_placeholder: '曾注册的手机号码',
    ap_confirm_otp: '确认 OTP',
    ap_otp_verify_alt: '输入 OTP 验证码以验证身份',
    ap_otp_4digit_placeholder: '请输入 4 位 OTP',
    ap_confirm_password_title: '请确认密码',
    ap_enter_password_placeholder: '请输入密码',
    ap_found_problem: '遇到问题',
    ap_contact_support: '联系客服',
    ap_notify: '通知',
    ap_phone_placeholder: '手机号码',
    ap_password_placeholder: '密码',

    ap_choose_promo_before_topup: '充值前选择优惠',
    ap_promo_default_alt: '百家乐 赌场 在线老虎机 promotion default',
    ap_problem: '遇到问题',
    ap_min_deposit_100: '最低充值 100',
    ap_min_deposit_10: '最低充值 10',
    ap_bank_prefix: '银行 ',
    ap_use_registered_account_only: '请仅使用您注册的账号转账。',
    ap_if_problem: '如果遇到问题',
    ap_want_promo: '想要领取优惠',
    ap_min_deposit_dyn_prefix: '最低充值 ',
    ap_max_dyn_mid: ' 最高 ',
    ap_baht_suffix: ' 泰铢',
    ap_deposit_truemoney_title: '充值 TrueMoney',
    ap_enter_gift_link_placeholder: '输入礼物链接',
    ap_wallet_prefix: '钱包 ',

    ap_min_withdraw_1: '最低提款 1',
    ap_credit_available: '可用积分',

    ap_account_info: '账户信息',
    ap_change_password: '修改密码',
    ap_current_password_placeholder: '当前密码',
    ap_new_password_placeholder: '新密码',
    ap_confirm_placeholder: '确认',
    ap_rank_condition_prefix: '等级条件 ',
    ap_deposit_more_prefix: '再存 ',
    ap_member_benefit: 'Member 等级将获得特殊权益和更好的优惠。',
    ap_account_number_label: '账号：',
    ap_account_name_label: '账户名：',
    ap_change_account_contact: '*如需更改账户，请',
    ap_use_coupon: '使用优惠券',
    ap_coupon_code_placeholder: '优惠券代码',

    ap_menu_account_info: '账户信息',
    ap_menu_invite_friend: '邀请好友',
    ap_menu_cashback: '亏损返现',
    ap_menu_history: '历史',
    ap_menu_history_full: '交易历史',
    ap_menu_use_coupon: '使用优惠券',
    ap_menu_joined_promo: '已参加的优惠',
    ap_menu_logout: '退出登录',
    ap_logout_confirm_title: '您要退出登录吗？',
    ap_menu_cashback2: '领取亏损返现',

    ap_get_cashback_bonus_prefix: '领取亏损奖金 ',
    ap_bonus_amount_period: '此期间的奖金金额 ',
    ap_get_loss: '领取亏损',
    ap_not_eligible: '不符合条件',
    ap_you_got_loss_prefix: '您获得了亏损奖金 ',
    ap_not_eligible_bonus: '您不符合领取奖金的条件。',
    ap_read_condition_join: '请阅读参加条件',
    ap_below: '在下方。',
    ap_read_condition: '请阅读条件',
    ap_get_rank_bonus: '领取 Rank 奖金',
    ap_success: '成功',
    ap_not_passed_condition: '尚未满足条件',

    ap_history_title: '交易历史',
    ap_bonus_special: '*特别奖金',
    ap_status_label: '状态：',
    ap_status_processing: '处理中',
    ap_status_pending: '等待处理',
    ap_status_cancel_by_player: '已取消（玩家取消）',
    ap_status_cancel_by_player_short: '已取消（玩家）',
    ap_status_fail_by_system: '失败（系统）',
    ap_status_success: '成功',

    ap_invite_friend_title: '邀请好友',
    ap_get_invite_link: '获取邀请链接',
    ap_click_link: '点击链接 ',
    ap_name_list: '已有的名单',
    ap_complete_min_deposit_100: '已满足最低充值 100 泰铢的条件 ',
    ap_you_got_invite_credit: '您获得邀请好友积分',
    ap_calc_every_sunday: '泰铢（每周日 00:00 计算）',
    ap_you_got_percent: '您获得百分比  ',
    ap_from_loss_received: ' 来自亏损，获得金额 ',

    ap_cashback_title: '亏损返现',
    ap_cashback_condition: '领取亏损返现的条件  ',
    ap_you_got_cashback: '您获得亏损返现金额 ',
    ap_give_invite_credit: '给予邀请好友积分',
    ap_give_first_deposit_credit: '给予首次充值积分',
    ap_calc_every_sunday2: '（每周日计算。）',

    ap_joined_promo: '已参加的优惠',
    ap_get_bonus_not_open: '领取奖金（此优惠尚未开放）',
    ap_promo_not_open: '此优惠尚未开放',
    ap_promo_rank_more: '提升 Rank 的优惠 ',

    ap_promotion: '优惠',
    ap_promo_not_active: '优惠尚未启用',
    ap_get_promo: '领取优惠',

    ap_bank_down: '银行目前出现故障',
    ap_sorry_inconvenience: '对于带来的不便我们深表歉意。',
    ap_2_months_ago: '2 个月前',
    ap_invite_more_get_more: '邀请越多得到越多',
    ap_invite_friend_play: '邀请好友来玩，最高可得 300 泰铢，邀请满 10 人',
    ap_get_extra_1000: '立即额外获得 1000 泰铢',
    ap_contact_service: '更多咨询请联系客服 @betsup',
    ap_3_months_ago: '3 个月前',
    ap_delete_all: '全部删除',

    ap_enter_game: '进入游戏',
    ap_chrome_step1a: '打开 Google Chrome',
    ap_chrome_step1b: '搜索 "Label" 进入网站',
    ap_chrome_step2a: '点击 ',
    ap_chrome_step2b: '选择"添加到主屏幕"',
    ap_chrome_step3a: '点击"添加"将游戏快捷方式',
    ap_chrome_step3b: '添加到主屏幕',
    ap_chrome_step4a: '检查页面',
    ap_chrome_step4b: '主屏幕上图标是否已出现',

    ap_baccarat: '百家乐',
    ap_casino: '赌场',
    ap_wheel: '转盘',

    ap_promo_available: '可领取的优惠',
    ap_cancel_promo: '取消优惠',
    ap_receive_promo: '领取优惠',
    ap_balance_remaining: '剩余余额',
    ap_turnover_label: '流水 ',
    ap_transfer_within: '请在以下时间内转账：',
    ap_5_minutes: ' 5 分钟',
    ap_no_promo_text: '不领取优惠',
    ap_after_transfer_press: '转账后，请不要忘记点击 ',
    ap_below_here: ' 下方这里。',
    ap_edit_deposit_confirm: '您要编辑充值金额吗？',
    ap_upload_slip: '上传凭证',
    ap_slip_max_5mb: '图片大小不得超过 5MB',
    ap_slip_required_note: '**必需** 请勿从其他屏幕拍照 ',
    ap_slip_qr_clear: '凭证中清晰可见',
    ap_and_must_see_qr: ' 并且必须能看到 QRCode',

    ap_toprank: '排行榜',
    ap_strategy: '策略',
    ap_invite_friend_nav: '邀请好友',
    ap_join_promo: '参加优惠',
    ap_you_got_loss_credit: '您获得亏损积分',

    // ===== ap2_ =====
    ap2_ticker_main: 'Ae sexy 在线娱乐场、在线老虎机，让您尽享各种玩法乐趣',
    ap2_footer_title_a: 'Ae sexyCASINO th 在线娱乐场网站 ',
    ap2_footer_title_b: '连续 3 年稳居泰国人心中第一',
    ap2_footer_content: 'Ae sexyCasino 百家乐、最佳在线娱乐场，为玩家带来真正出色的体验，尽显 Ae sexyCasino 风范',
    ap2_tag_casino: 'Ae sexy 娱乐场',
    ap2_tag_casino_online: 'Ae sexy 在线娱乐场',
    ap2_tag_baccarat: 'Ae sexy 百家乐',
    ap2_tag_live_casino: '真人娱乐场',
    ap2_share_copied_msg: '已复制',
    ap2_share_caption: `🌎 AE Sexy，您必须体验的第一名
🔥 新会员存 100 得 150
🔥 新会员存 300 得 500
🔥 新会员获 50% 奖金，最高 1,000
🔥 火热优惠：存 1000 免费送 100，无任何条件
🔥 赢了再加送，输了每周六返 5%，终身可领
🎁 存提款 3 秒到账，采用泰国唯一真正可用的 AI 系统

#分享赚取 #每天可领 #人人可做 #简单几步 #好网站强优惠 #第一名 #aesexy #存提最快
#最佳Ae`,
    ap2_tc_play_more_lose_back_prefix: '赢了再加送，输了返还 ',
    ap2_tc_play_more_lose_back_suffix: ' %，每周',
    ap2_tc_play_more_lose_back_5: '赢了再加送，输了每周返还 5%',
    ap2_tc_calc_week_mon: '► 按 1 周计算（自周一 00:01 至周日 23:59）',
    ap2_tc_calc_week_sat: '► 按 1 周计算（自周六 00:01 至周五 23:59）',
    ap2_tc_turnover_5x: '► 一周内须达到存款额 5 倍的流水',
    ap2_tc_bonus_every_mon: '► 奖金每周一发放，可在网站页面领取',
    ap2_tc_bonus_every_sat: '► 奖金每周六发放，可在网站页面领取',
    ap2_tc_bonus_no_turnover: '► 所得奖金无需流水，可立即提款！',
    ap2_tc_min_winloss_500: '► 每周输赢金额超过 500 泰铢方可获得 5% 奖金',
    ap2_tc_min_winloss_2000: '► 每周输赢金额超过 2000 泰铢方可获得 5% 奖金',
    ap2_tc_credit_expire_7: '► 领取优惠后，积分有效期为 7 天，之后亏损返现积分将被调整为 0',
    ap2_tc_credit_expire_3: '► 领取优惠后，积分有效期为 3 天，之后亏损返现积分将被调整为 0',
    ap2_tc_basic_rules: '基本条款与规则将适用于此优惠',
    ap2_topup_word: '存',
    ap2_topup_word_baht: ' 泰铢 ',
    ap2_topup_word_baht_more: ' 泰铢以上 ',
    ap2_bonus_word: '奖金 ',
    ap2_bonus_baht_invite: ' 泰铢，邀请好友 ',
    ap2_bonus_baht_only: ' 泰铢',
    ap2_time_suffix: '时',
    ap2_months_mini: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  },
  ja: {
    ap_ok: 'OK',
    ap_confirm: '確認',
    ap_cancel: 'キャンセル',
    ap_back: '戻る',
    ap_back2: '戻る',
    ap_next: '次へ',
    ap_copy: 'コピー',
    ap_copied: 'コピーしました',
    ap_copied_excl: 'コピーしました！',
    ap_acknowledge: '了解',
    ap_done: '完了',
    ap_claim: '受け取る',
    ap_baht: 'バーツ',
    ap_credit_unit: 'クレジット',
    ap_login: 'ログイン',
    ap_register: '登録',
    ap_register_now: '今すぐ登録',
    ap_login_short: 'ログイン',
    ap_deposit: '入金',
    ap_withdraw: '出金',
    ap_topup: 'チャージ',
    ap_topup_payment: 'Payment チャージ',
    ap_no_data: 'データが見つかりません',
    ap_no_history: 'まだ取引履歴がありません。',
    ap_no_affiliate: 'まだ友達紹介のデータがありません。',
    ap_no_cashback: 'まだキャッシュバックの記録がありません。',

    ap_withdraw_insufficient: '出金残高が不足しています。',
    ap_session_expired: 'セッションの有効期限が切れました。再度ログインしてください。',
    ap_promo_pending_can_topup: '保留中のプロモーションがあります。今すぐチャージできます。',
    ap_promo_received: 'プロモーションを正常に受け取りました。',
    ap_promo_not_eligible: 'このプロモーションの条件を満たしていません。',
    ap_quota_used_today: '本日の回数を使い切りました。',
    ap_promo_already_used: 'このプロモーションはすでに使用済みです。',
    ap_processing_please_wait: 'お待ちください。処理中です。',
    ap_enter_gift_link_min10: '下記にギフトリンクを入力してください。最低 10 バーツ。',
    ap_truemoney_topup_success: 'チャージ成功、金額 ',
    ap_gift_link_used: 'このギフトリンクはすでに使用済みで、再度使用できません。',
    ap_gift_link_not_yours: 'チャージリンクはあなたの口座名義ではありません。確認してください。',
    ap_truemoney_closed: 'TrueMoney チャージは停止中です。アップデートをお待ちください。',
    ap_gift_link_failed: '取引が失敗したか、リンクが使用できません。 ',
    ap_no_gift_link: 'ギフトリンクが入力されていません。 ',
    ap_processing_please_wait2: '処理中です。少々お待ちください。',
    ap_scan_qr_within_5min: '5 分以内に QR コードをスキャンしてください。',
    ap_min_deposit_prefix: '最低チャージ ',
    ap_max_deposit_mid: ' バーツ、最高 ',
    ap_claim_rank_question: 'Rank を受け取りますか？',
    ap_action_done: '操作が完了しました。',
    ap_action_failed_wait: '処理できません。少々お待ちください。',
    ap_received_money_done: '入金処理が完了しました。',
    ap_no_balance: '処理できません。残高がありません。',
    ap_action_failed: '処理できません。',
    ap_password_changed: 'パスワードが正常に変更されました。',
    ap_old_password_wrong: '古いパスワードが間違っています。',
    ap_error_try_again: 'エラーが発生しました。もう一度お試しください。',
    ap_same_password: '同じパスワードを使用しています。',
    ap_password_mismatch: 'パスワードが一致しません。',
    ap_phone_invalid: '電話番号が間違っています。',
    ap_phone_in_use: 'この電話番号はすでに使用されています。',
    ap_too_frequent: '操作が頻繁すぎます。少々お待ちください。',
    ap_select_bank_or_complete: '銀行を選択するか、情報をすべて入力してください！！',
    ap_otp_incomplete: '数字が入力しきれていません。',
    ap_otp_wrong: 'コードが間違っています。',
    ap_phone_not_found: 'この電話番号はシステムにありません。',
    ap_withdraw_done: '出金が完了しました。',
    ap_withdraw_partial_prefix: '取引成功。最大 ',
    ap_withdraw_partial_suffix: ' バーツまで出金できます。ボーナスを受け取ったため、残りのクレジットは差し引かれます。',
    ap_turnover_remaining_prefix: 'あと Turnover ',
    ap_turnover_remaining_suffix: ' バーツ必要です。',
    ap_withdraw_problem: '出金に問題があります。スタッフにお問い合わせください。',
    ap_min_withdraw_100: '最低出金額は 100 バーツです。',
    ap_cancel_withdraw_question: '出金をキャンセルしますか？',
    ap_cancel_promo_question: 'プロモーションの使用をキャンセルしますか？',
    ap_coupon_used_done: 'クーポンが正常に使用されました。',
    ap_coupon_not_found: 'この Key はシステムにありません。',
    ap_force_withdraw_all: '全額強制出金。',
    ap_not_login: ' ログインしていません',
    ap_password_min6: 'パスワードが 6 文字未満です。確認してください。',
    ap_no_phone_input: '電話番号が入力されていません。',
    ap_no_account_input: '銀行口座番号が入力されていません。',
    ap_no_name_input: '氏名が入力されていません。',
    ap_no_bank_selected: '銀行が選択されていません。',
    ap_register_pass_mismatch: 'パスワードが一致しません。',
    ap_register_done_login: '登録が完了しました。再度ログインしてください。',
    ap_username_taken: 'このユーザー名はすでに登録されています。',
    ap_username_or_name_invalid: 'ユーザー名または登録名が正しくありません。',

    ap_share_earn_title: 'シェアして稼ぐ',
    ap_share_earn_alt: 'シェアして稼ぐ',
    ap_go_to_page: 'ページへアクセス：',
    ap_share_pinned_post: 'そして固定投稿をシェア',
    ap_copy_caption_hashtag: 'キャプションとハッシュタグをコピーして投稿に入れ、コメントを書く',
    ap_paste_caption_hashtag: 'キャプションとハッシュタグを貼り付ける',
    ap_fb_public_share: 'Facebook ページを公開、1 投稿、2 グループへシェア、そして',
    ap_like_page: 'ページにいいね：',
    ap_copy_each_link: '各投稿のリンクをコピー',
    ap_attach_evidence_each: '証拠として添付するため（投稿ごとに 1 リンク）',
    ap_share_complete_attach: 'シェア条件を完了したら、「ファイルを添付して権利を受け取る」を押す',
    ap_to_get_bonus: 'ボーナスを受け取るため',
    ap_admin_check_next_day: '管理者は翌日にリンクから投稿を確認します',
    ap_credit_after_check: '管理者の確認完了後すぐにクレジットが入ります',
    ap_no_evidence_forfeit: 'ただしリンクに証拠が見つからない場合は放棄とみなされます ❌',
    ap_real_active_account: 'アクティブな実在のアカウントで、公開投稿に設定する必要があります',
    ap_for_verification: '確認のため',
    ap_fb_friends_300: 'シェアして稼ぐを行う Facebook アカウントは 300 人以上の',
    ap_people_more: '友達が必要です',
    ap_group_public_1000: 'シェアするグループは公開グループで、1,000 人以上の',
    ap_people_more2: 'メンバーが必要です',
    ap_limit_1_per_day: '1 人 1 日 1 回まで',
    ap_withdraw_share_condition: 'シェアして稼ぐのクレジットは 500 バーツ以上入金後にのみ出金可能',
    ap_within_14_days: '14 日以内に',
    ap_member_must: 'メンバーは',
    ap_open_public_post: '公開投稿に設定する',
    ap_verify_or_forfeit: '確認のため、そうでない場合は放棄とみなされます',
    ap_copy_caption_comment: '投稿とコメント用にキャプション、ハッシュタグをコピー',
    ap_paste_caption_hashtag2: 'キャプションとハッシュタグを貼り付ける',
    ap_share_now_good: '「今すぐシェア」を押すと facebook へシェアする良いものがあります',
    ap_share_now: '今すぐシェア',
    ap_attach_evidence_get: '証拠を添付して権利を受け取る',
    ap_bonus_wait_confirm: 'ボーナスを受け取り、確認をお待ちください',
    ap_evidence_link1: '証拠リンク 1',
    ap_evidence_link2: '証拠リンク 2',
    ap_evidence_link3: '証拠リンク 3',
    ap_send_evidence: '証拠を送る',
    ap_submit_evidence: '証拠を提出する',

    ap_notify_board: 'お知らせボード',
    ap_forgot_password_title: 'パスワードをお忘れですか',
    ap_forgot_password: 'パスワードをお忘れですか',
    ap_phone_registered_placeholder: '登録済みの電話番号',
    ap_confirm_otp: 'OTP を確認',
    ap_otp_verify_alt: '本人確認のため OTP コードを入力',
    ap_otp_4digit_placeholder: '4 桁の OTP を入力してください',
    ap_confirm_password_title: 'パスワードを確認してください',
    ap_enter_password_placeholder: 'パスワードを入力してください',
    ap_found_problem: '問題が発生しました',
    ap_contact_support: 'カスタマーサービスに連絡',
    ap_notify: 'お知らせ',
    ap_phone_placeholder: '電話番号',
    ap_password_placeholder: 'パスワード',

    ap_choose_promo_before_topup: 'チャージ前にプロモーションを選択',
    ap_promo_default_alt: 'バカラ カジノ オンラインスロット promotion default',
    ap_problem: '問題が発生',
    ap_min_deposit_100: '最低チャージ 100',
    ap_min_deposit_10: '最低チャージ 10',
    ap_bank_prefix: '銀行 ',
    ap_use_registered_account_only: '登録した口座からのみ振り込んでください。',
    ap_if_problem: '問題が発生した場合',
    ap_want_promo: 'プロモーションを受け取りたい',
    ap_min_deposit_dyn_prefix: '最低チャージ ',
    ap_max_dyn_mid: ' 最高 ',
    ap_baht_suffix: ' バーツ',
    ap_deposit_truemoney_title: 'TrueMoney 入金',
    ap_enter_gift_link_placeholder: 'ギフトリンクを入力',
    ap_wallet_prefix: 'ウォレット ',

    ap_min_withdraw_1: '最低出金 1',
    ap_credit_available: '利用可能なクレジット',

    ap_account_info: '口座情報',
    ap_change_password: 'パスワード変更',
    ap_current_password_placeholder: '現在のパスワード',
    ap_new_password_placeholder: '新しいパスワード',
    ap_confirm_placeholder: '確認',
    ap_rank_condition_prefix: 'ランク条件 ',
    ap_deposit_more_prefix: 'あと ',
    ap_member_benefit: 'Member ランクは特別な特典とより良いプロモーションを受けられます。',
    ap_account_number_label: '口座番号：',
    ap_account_name_label: '口座名義：',
    ap_change_account_contact: '*口座を変更したい場合は、',
    ap_use_coupon: 'クーポンを使う',
    ap_coupon_code_placeholder: 'クーポンコード',

    ap_menu_account_info: '口座情報',
    ap_menu_invite_friend: '友達を招待',
    ap_menu_cashback: '損失キャッシュバック',
    ap_menu_history: '履歴',
    ap_menu_history_full: '取引履歴',
    ap_menu_use_coupon: 'クーポンを使う',
    ap_menu_joined_promo: '参加したプロモーション',
    ap_menu_logout: 'ログアウト',
    ap_logout_confirm_title: 'ログアウトしますか？',
    ap_menu_cashback2: '損失キャッシュバックを受け取る',

    ap_get_cashback_bonus_prefix: '損失ボーナスを受け取る ',
    ap_bonus_amount_period: 'この期間のボーナス額 ',
    ap_get_loss: '損失を受け取る',
    ap_not_eligible: '条件を満たしていません',
    ap_you_got_loss_prefix: '損失ボーナスを受け取りました ',
    ap_not_eligible_bonus: 'ボーナスを受け取る条件を満たしていません。',
    ap_read_condition_join: '参加条件をお読みください',
    ap_below: '下記に。',
    ap_read_condition: '条件をお読みください',
    ap_get_rank_bonus: 'Rank ボーナスを受け取る',
    ap_success: '成功',
    ap_not_passed_condition: 'まだ条件を満たしていません',

    ap_history_title: '取引履歴',
    ap_bonus_special: '*特別ボーナス',
    ap_status_label: 'ステータス：',
    ap_status_processing: '処理中',
    ap_status_pending: '処理待ち',
    ap_status_cancel_by_player: 'キャンセル（プレイヤーによるキャンセル）',
    ap_status_cancel_by_player_short: 'キャンセル（プレイヤー）',
    ap_status_fail_by_system: '失敗（システム）',
    ap_status_success: '成功',

    ap_invite_friend_title: '友達を招待',
    ap_get_invite_link: '紹介リンクを取得',
    ap_click_link: 'リンクをクリック ',
    ap_name_list: 'ある名前リスト',
    ap_complete_min_deposit_100: '最低チャージ 100 バーツの条件を満たしました ',
    ap_you_got_invite_credit: '友達紹介クレジットを受け取りました',
    ap_calc_every_sunday: 'バーツ（毎週日曜日 00:00 に計算）',
    ap_you_got_percent: 'パーセントを獲得しました  ',
    ap_from_loss_received: ' 損失から、受取額 ',

    ap_cashback_title: '損失キャッシュバック',
    ap_cashback_condition: '損失キャッシュバックを受け取る条件  ',
    ap_you_got_cashback: '損失キャッシュバックを受け取りました ',
    ap_give_invite_credit: '友達紹介クレジットを付与',
    ap_give_first_deposit_credit: '初回チャージクレジットを付与',
    ap_calc_every_sunday2: '（毎週日曜日に計算。）',

    ap_joined_promo: '参加したプロモーション',
    ap_get_bonus_not_open: 'ボーナスを受け取る（このプロモーションはまだ開始していません）',
    ap_promo_not_open: 'このプロモーションはまだ開始していません',
    ap_promo_rank_more: 'Rank を上げるプロモーション ',

    ap_promotion: 'プロモーション',
    ap_promo_not_active: 'プロモーションはまだ有効になっていません',
    ap_get_promo: 'プロモーションを受け取る',

    ap_bank_down: '現在、銀行が利用できません',
    ap_sorry_inconvenience: 'ご不便をおかけして申し訳ございません。',
    ap_2_months_ago: '2 ヶ月前',
    ap_invite_more_get_more: '招待すればするほど得をする',
    ap_invite_friend_play: '友達を招待してプレイ、最大 300 バーツ、10 人招待すると',
    ap_get_extra_1000: 'さらに 1000 バーツを即時獲得',
    ap_contact_service: '詳しくはサービス @betsup までお問い合わせください',
    ap_3_months_ago: '3 ヶ月前',
    ap_delete_all: 'すべて削除',

    ap_enter_game: 'ゲームに入る',
    ap_chrome_step1a: 'Google Chrome を開く',
    ap_chrome_step1b: '"Label" を検索してウェブサイトへ',
    ap_chrome_step2a: 'タップ ',
    ap_chrome_step2b: '「ホーム画面に追加」を選択',
    ap_chrome_step3a: '「追加」をタップしてゲームのショートカットを',
    ap_chrome_step3b: 'ホーム画面に',
    ap_chrome_step4a: 'ページを確認',
    ap_chrome_step4b: 'ホーム画面にアイコンが表示されたか',

    ap_baccarat: 'バカラ',
    ap_casino: 'カジノ',
    ap_wheel: 'ホイール',

    ap_promo_available: '受け取り可能なプロモーション',
    ap_cancel_promo: 'プロモーションをキャンセル',
    ap_receive_promo: 'プロモーションを受け取る',
    ap_balance_remaining: '残高',
    ap_turnover_label: 'ターンオーバー ',
    ap_transfer_within: '以下の時間内にお振込ください：',
    ap_5_minutes: ' 5 分',
    ap_no_promo_text: 'プロモーションを受け取らない',
    ap_after_transfer_press: '振込後、忘れずに押してください ',
    ap_below_here: ' 下記をここで。',
    ap_edit_deposit_confirm: '入金額を編集しますか？',
    ap_upload_slip: '伝票をアップロード',
    ap_slip_max_5mb: '画像のサイズは 5MB を超えてはいけません',
    ap_slip_required_note: '**必須** 他の画面から撮影しないでください ',
    ap_slip_qr_clear: '伝票内ではっきりと',
    ap_and_must_see_qr: ' そして QRCode が見える必要があります',

    ap_toprank: 'ランキング',
    ap_strategy: '戦略',
    ap_invite_friend_nav: '友達を招待',
    ap_join_promo: 'プロモーション参加',
    ap_you_got_loss_credit: '損失クレジットを受け取りました',

    // ===== ap2_ =====
    ap2_ticker_main: 'Ae sexy オンラインカジノ・オンラインスロット。あらゆるスタイルで楽しめます',
    ap2_footer_title_a: 'Ae sexyCASINO th オンラインカジノサイト ',
    ap2_footer_title_b: 'タイ人の心の中で3年連続第1位',
    ap2_footer_content: 'Ae sexyCasino バカラ、最高のオンラインカジノ。プレイヤーに真に優れた体験をお届けする Ae sexyCasino スタイル',
    ap2_tag_casino: 'Ae sexy カジノ',
    ap2_tag_casino_online: 'Ae sexy オンラインカジノ',
    ap2_tag_baccarat: 'Ae sexy バカラ',
    ap2_tag_live_casino: 'ライブカジノ',
    ap2_share_copied_msg: 'コピーしました',
    ap2_share_caption: `🌎 AE Sexy、体験すべき第1位
🔥 新規会員 100 で 150 ゲット
🔥 新規会員 300 で 500 ゲット
🔥 新規会員は最大 1,000 の 50% ボーナス
🔥 ホットプロモ：1000 入金で 100 無料、条件なし
🔥 勝てば上乗せ、負ければ毎週土曜に5%返還、生涯受取可能
🎁 入出金3秒、タイ唯一の実用 AI システム搭載

#シェアして稼ぐ #毎日受取 #誰でもできる #簡単数ステップ #良いサイト強いプロモ #第1位 #aesexy #最速入出金
#最高のAe`,
    ap2_tc_play_more_lose_back_prefix: '勝てば上乗せ、負ければ ',
    ap2_tc_play_more_lose_back_suffix: ' % を毎週返還',
    ap2_tc_play_more_lose_back_5: '勝てば上乗せ、負ければ毎週5%返還',
    ap2_tc_calc_week_mon: '► 1週間で計算（月曜 00:01 から日曜 23:59 まで）',
    ap2_tc_calc_week_sat: '► 1週間で計算（土曜 00:01 から金曜 23:59 まで）',
    ap2_tc_turnover_5x: '► 週内に入金額の5倍のターンオーバーが必要です',
    ap2_tc_bonus_every_mon: '► ボーナスは毎週月曜に付与され、ウェブサイトで受け取れます',
    ap2_tc_bonus_every_sat: '► ボーナスは毎週土曜に付与され、ウェブサイトで受け取れます',
    ap2_tc_bonus_no_turnover: '► 受け取ったボーナスはターンオーバー不要で、すぐに出金できます！',
    ap2_tc_min_winloss_500: '► 週の勝敗額が500バーツを超える場合のみ5%ボーナスを受け取れます',
    ap2_tc_min_winloss_2000: '► 週の勝敗額が2000バーツを超える場合のみ5%ボーナスを受け取れます',
    ap2_tc_credit_expire_7: '► プロモーション受取後、クレジットの有効期限は7日間で、その後損失キャッシュバッククレジットは0に調整されます',
    ap2_tc_credit_expire_3: '► プロモーション受取後、クレジットの有効期限は3日間で、その後損失キャッシュバッククレジットは0に調整されます',
    ap2_tc_basic_rules: 'このプロモーションには基本的な規約とルールが適用されます',
    ap2_topup_word: '入金',
    ap2_topup_word_baht: ' バーツ ',
    ap2_topup_word_baht_more: ' バーツ以上 ',
    ap2_bonus_word: 'ボーナス ',
    ap2_bonus_baht_invite: ' バーツ、友達招待 ',
    ap2_bonus_baht_only: ' バーツ',
    ap2_time_suffix: '時',
    ap2_months_mini: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  },
  my: {
    ap_ok: 'အိုကေ',
    ap_confirm: 'အတည်ပြုမည်',
    ap_cancel: 'ပယ်ဖျက်မည်',
    ap_back: 'နောက်သို့',
    ap_back2: 'နောက်သို့',
    ap_next: 'ရှေ့သို့',
    ap_copy: 'ကူးယူမည်',
    ap_copied: 'ကူးယူပြီးပါပြီ',
    ap_copied_excl: 'ကူးယူပြီးပါပြီ!',
    ap_acknowledge: 'သဘောပေါက်ပါသည်',
    ap_done: 'ပြီးပါပြီ',
    ap_claim: 'ရယူမည်',
    ap_baht: 'ဘတ်',
    ap_credit_unit: 'ခရက်ဒစ်',
    ap_login: 'အကောင့်ဝင်ရန်',
    ap_register: 'အကောင့်ဖွင့်ရန်',
    ap_register_now: 'ယခုဖွင့်ရန်',
    ap_login_short: 'ဝင်ရန်',
    ap_deposit: 'ငွေသွင်းရန်',
    ap_withdraw: 'ငွေထုတ်ရန်',
    ap_topup: 'ငွေဖြည့်ရန်',
    ap_topup_payment: 'Payment ဖြည့်ရန်',
    ap_no_data: 'ဒေတာမတွေ့ပါ',
    ap_no_history: 'သင့်တွင် ငွေလွှဲမှတ်တမ်း မရှိသေးပါ။',
    ap_no_affiliate: 'သင့်တွင် မိတ်ဆွေဖိတ်ခေါ်မှု ဒေတာ မရှိသေးပါ။',
    ap_no_cashback: 'သင့်တွင် ငွေပြန်အမ်းမှတ်တမ်း မရှိသေးပါ။',

    ap_withdraw_insufficient: 'သင့်ထုတ်ယူနိုင်သော လက်ကျန်ငွေ မလုံလောက်ပါ။',
    ap_session_expired: 'သင့် Session သက်တမ်းကုန်သွားပါပြီ။ ကျေးဇူးပြု၍ ပြန်လည်ဝင်ရောက်ပါ။',
    ap_promo_pending_can_topup: 'သင့်တွင် ဆိုင်းငံ့ထားသော ပရိုမိုးရှင်း ရှိပါသည်။ ယခု ငွေဖြည့်နိုင်ပါသည်။',
    ap_promo_received: 'ပရိုမိုးရှင်း အောင်မြင်စွာ ရရှိပါပြီ။',
    ap_promo_not_eligible: 'ဤပရိုမိုးရှင်း၏ စည်းကမ်းချက်များနှင့် မကိုက်ညီပါ။',
    ap_quota_used_today: 'ယနေ့အတွက် သင့်အခွင့်အရေး ကုန်သွားပါပြီ။',
    ap_promo_already_used: 'ဤပရိုမိုးရှင်းကို သင်အသုံးပြုပြီးဖြစ်ပါသည်။',
    ap_processing_please_wait: 'ကျေးဇူးပြု၍ စောင့်ပါ၊ ဆောင်ရွက်နေပါသည်။',
    ap_enter_gift_link_min10: 'အောက်တွင် လက်ဆောင်လင့်ခ် ထည့်ပါ၊ အနည်းဆုံး ၁၀ ဘတ်။',
    ap_truemoney_topup_success: 'ငွေဖြည့်ခြင်း အောင်မြင်ပါသည်၊ ပမာဏ ',
    ap_gift_link_used: 'ဤလက်ဆောင်လင့်ခ်ကို အသုံးပြုပြီးဖြစ်၍ ထပ်မံအသုံးပြု၍မရပါ။',
    ap_gift_link_not_yours: 'ငွေဖြည့်လင့်ခ်သည် သင့်အကောင့်အမည် မဟုတ်ပါ။ စစ်ဆေးပါ။',
    ap_truemoney_closed: 'TrueMoney ငွေဖြည့်ခြင်း ပိတ်ထားသည်၊ အပ်ဒိတ်ကို စောင့်ပါ။',
    ap_gift_link_failed: 'လုပ်ဆောင်ချက် မအောင်မြင်ပါ သို့မဟုတ် လင့်ခ် အသုံးမပြုနိုင်ပါ။ ',
    ap_no_gift_link: 'သင် လက်ဆောင်လင့်ခ် မထည့်ထားပါ။ ',
    ap_processing_please_wait2: 'ဆောင်ရွက်နေပါသည်၊ ခဏစောင့်ပါ။',
    ap_scan_qr_within_5min: 'ကျေးဇူးပြု၍ ၅ မိနစ်အတွင်း QR ကုဒ်ကို စကင်န်ဖတ်ပါ။',
    ap_min_deposit_prefix: 'အနည်းဆုံး ငွေဖြည့် ',
    ap_max_deposit_mid: ' ဘတ် အများဆုံး ',
    ap_claim_rank_question: 'Rank ကို ရယူလိုပါသလား။',
    ap_action_done: 'ဆောင်ရွက်မှု ပြီးဆုံးပါပြီ။',
    ap_action_failed_wait: 'ဆောင်ရွက်၍မရပါ။ ခဏစောင့်ပါ။',
    ap_received_money_done: 'ငွေလက်ခံခြင်း ပြီးဆုံးပါပြီ။',
    ap_no_balance: 'ဆောင်ရွက်၍မရပါ၊ လက်ကျန်ငွေ မရှိပါ။',
    ap_action_failed: 'ဆောင်ရွက်၍မရပါ။',
    ap_password_changed: 'စကားဝှက် အောင်မြင်စွာ ပြောင်းလဲပြီးပါပြီ။',
    ap_old_password_wrong: 'သင် စကားဝှက်အဟောင်း မှားယွင်းစွာ ထည့်ထားပါသည်။',
    ap_error_try_again: 'အမှားအယွင်း ဖြစ်ပွားပါသည်။ ထပ်မံကြိုးစားပါ။',
    ap_same_password: 'သင် စကားဝှက်အဟောင်းကို အသုံးပြုထားပါသည်။',
    ap_password_mismatch: 'သင့်စကားဝှက်များ မကိုက်ညီပါ။',
    ap_phone_invalid: 'သင် ဖုန်းနံပါတ် မှားယွင်းစွာ ထည့်ထားပါသည်။',
    ap_phone_in_use: 'ဤဖုန်းနံပါတ်ကို အသုံးပြုပြီးဖြစ်ပါသည်။',
    ap_too_frequent: 'သင် အကြိမ်ရေများလွန်းစွာ လုပ်ဆောင်နေပါသည်။ ခဏစောင့်ပါ။',
    ap_select_bank_or_complete: 'ကျေးဇူးပြု၍ ဘဏ်ကို ရွေးချယ်ပါ သို့မဟုတ် အချက်အလက်အပြည့်အစုံ ဖြည့်ပါ။',
    ap_otp_incomplete: 'သင် ဂဏန်းများ မပြည့်စုံစွာ ထည့်ထားပါသည်။',
    ap_otp_wrong: 'ကုဒ်မှားယွင်းပါသည်။',
    ap_phone_not_found: 'ဤဖုန်းနံပါတ်သည် စနစ်တွင် မရှိပါ။',
    ap_withdraw_done: 'ငွေထုတ်ခြင်း ပြီးဆုံးပါပြီ။',
    ap_withdraw_partial_prefix: 'လုပ်ဆောင်ချက် အောင်မြင်ပါသည်။ သင် အများဆုံး ',
    ap_withdraw_partial_suffix: ' ဘတ် ထုတ်ယူနိုင်ပါသည်၊ အကြောင်းမှာ သင် ဘောနပ်စ်ရရှိ၍ ကျန်ခရက်ဒစ်ကို ဖြတ်တောက်ပါမည်။',
    ap_turnover_remaining_prefix: 'သင်တွင် Turnover ',
    ap_turnover_remaining_suffix: ' ဘတ် ကျန်ပါသေးသည်။',
    ap_withdraw_problem: 'ငွေထုတ်ခြင်းတွင် ပြဿနာရှိပါသည်။ ဝန်ထမ်းကို ဆက်သွယ်ပါ။',
    ap_min_withdraw_100: 'အနည်းဆုံး ငွေထုတ်ခြင်း ၁၀၀ ဘတ်။',
    ap_cancel_withdraw_question: 'ငွေထုတ်ခြင်းကို ပယ်ဖျက်လိုပါသလား။',
    ap_cancel_promo_question: 'ပရိုမိုးရှင်း အသုံးပြုခြင်းကို ပယ်ဖျက်လိုပါသလား။',
    ap_coupon_used_done: 'ကူပွန် အောင်မြင်စွာ အသုံးပြုပြီးပါပြီ။',
    ap_coupon_not_found: 'ဤ Key သည် စနစ်တွင် မရှိပါ။',
    ap_force_withdraw_all: 'လက်ကျန်ငွေအားလုံး အတင်းအဓမ္မ ထုတ်ယူမည်။',
    ap_not_login: ' သင် အကောင့်ဝင်ထားခြင်း မရှိပါ',
    ap_password_min6: 'သင့်စကားဝှက်သည် ၆ လုံး မပြည့်ပါ။ စစ်ဆေးပါ။',
    ap_no_phone_input: 'သင် ဖုန်းနံပါတ် မထည့်ထားပါ။',
    ap_no_account_input: 'သင် ဘဏ်အကောင့်နံပါတ် မထည့်ထားပါ။',
    ap_no_name_input: 'သင် အမည် မထည့်ထားပါ။',
    ap_no_bank_selected: 'သင် ဘဏ်ကို မရွေးချယ်ရသေးပါ။',
    ap_register_pass_mismatch: 'သင့်စကားဝှက်များ မကိုက်ညီပါ။',
    ap_register_done_login: 'အကောင့်ဖွင့်ခြင်း ပြီးဆုံးပါပြီ။ ကျေးဇူးပြု၍ ပြန်ဝင်ပါ။',
    ap_username_taken: 'ဤ Username ကို အကောင့်ဖွင့်ပြီးဖြစ်ပါသည်။',
    ap_username_or_name_invalid: 'Username သို့မဟုတ် အကောင့်ဖွင့်အမည် မမှန်ကန်ပါ။',

    ap_share_earn_title: 'မျှဝေ၍ ဝင်ငွေရှာပါ',
    ap_share_earn_alt: 'မျှဝေ၍ ဝင်ငွေရှာပါ',
    ap_go_to_page: 'စာမျက်နှာသို့ သွားပါ：',
    ap_share_pinned_post: 'ပြီးလျှင် ပင်တွဲထားသော ပို့စ်ကို မျှဝေပါ',
    ap_copy_caption_hashtag: 'ပို့စ်တွင်ထည့်ရန် ခေါင်းစဉ်နှင့် ဟက်ရှ်တက်ကို ကူးယူ၍ မှတ်ချက်ရေးပါ',
    ap_paste_caption_hashtag: 'ခေါင်းစဉ်နှင့် ဟက်ရှ်တက်ကို ကူးထည့်ပါ',
    ap_fb_public_share: 'Facebook စာမျက်နှာ အများမြင်နိုင်ရန် ၁ ပို့စ်၊ ၂ အုပ်စုသို့ မျှဝေ၊ ပြီးလျှင်',
    ap_like_page: 'စာမျက်နှာကို Like လုပ်ပါ：',
    ap_copy_each_link: 'ပို့စ်တစ်ခုစီ၏ လင့်ခ်ကို ကူးယူပါ',
    ap_attach_evidence_each: 'အထောက်အထားအဖြစ် တွဲရန် (ပို့စ်တစ်ခုလျှင် ၁ လင့်ခ်)',
    ap_share_complete_attach: 'မျှဝေမှု စည်းကမ်းပြည့်လျှင် "ဖိုင်တွဲ၍ အခွင့်အရေးရယူရန်" ကို နှိပ်ပါ',
    ap_to_get_bonus: 'ဘောနပ်စ်ရရှိရန်',
    ap_admin_check_next_day: 'အက်ဒမင်သည် နောက်တစ်ရက်တွင် လင့်ခ်မှ ပို့စ်များကို စစ်ဆေးမည်',
    ap_credit_after_check: 'အက်ဒမင် စစ်ဆေးပြီးသည်နှင့် ခရက်ဒစ် ချက်ချင်းဝင်မည်',
    ap_no_evidence_forfeit: 'သို့သော် လင့်ခ်တွင် အထောက်အထား မတွေ့ပါက အခွင့်အရေး စွန့်လွှတ်ရာ ရောက်သည် ❌',
    ap_real_active_account: 'လှုပ်ရှားမှုရှိသော အကောင့်စစ်ဖြစ်ရမည်၊ အများမြင် ပို့စ်အဖြစ် ထားရမည်',
    ap_for_verification: 'စစ်ဆေးရန်အတွက်',
    ap_fb_friends_300: 'မျှဝေ၍ ဝင်ငွေရှာသော Facebook အကောင့်တွင် သူငယ်ချင်း ၃၀၀ ထက်',
    ap_people_more: 'ဦးအထက် ရှိရမည်',
    ap_group_public_1000: 'မျှဝေသော အုပ်စုသည် အများမြင် အုပ်စုဖြစ်ရမည်၊ အဖွဲ့ဝင် ၁,၀၀၀ ထက်',
    ap_people_more2: 'ဦးအထက် ရှိရမည်',
    ap_limit_1_per_day: 'တစ်ဦးလျှင် တစ်ရက် ၁ ကြိမ်သာ',
    ap_withdraw_share_condition: 'မျှဝေ၍ ဝင်ငွေရှာ ခရက်ဒစ်ကို ၅၀၀ ဘတ်အထက် ငွေသွင်းပြီးမှသာ ထုတ်ယူနိုင်သည်',
    ap_within_14_days: '၁၄ ရက်အတွင်း',
    ap_member_must: 'အဖွဲ့ဝင်များသည်',
    ap_open_public_post: 'အများမြင် ပို့စ်အဖြစ် ထားရမည်',
    ap_verify_or_forfeit: 'စစ်ဆေးရန်အတွက်၊ မဟုတ်ပါက အခွင့်အရေး စွန့်လွှတ်ရာ ရောက်မည်',
    ap_copy_caption_comment: 'ပို့စ်နှင့် မှတ်ချက်အတွက် ခေါင်းစဉ်၊ ဟက်ရှ်တက်ကို ကူးယူပါ',
    ap_paste_caption_hashtag2: 'ခေါင်းစဉ်နှင့် ဟက်ရှ်တက်ကို ကူးထည့်ပါ',
    ap_share_now_good: '"ယခုမျှဝေ" ကို နှိပ်လျှင် facebook သို့ မျှဝေရန် ကောင်းသောအရာများ ရှိမည်',
    ap_share_now: 'ယခုမျှဝေ',
    ap_attach_evidence_get: 'အထောက်အထား တွဲ၍ အခွင့်အရေး ရယူပါ',
    ap_bonus_wait_confirm: 'ဘောနပ်စ်ရယူ၍ အတည်ပြုချက်ကို စောင့်ပါ',
    ap_evidence_link1: 'အထောက်အထား လင့်ခ် ၁',
    ap_evidence_link2: 'အထောက်အထား လင့်ခ် ၂',
    ap_evidence_link3: 'အထောက်အထား လင့်ခ် ၃',
    ap_send_evidence: 'အထောက်အထား ပို့ရန်',
    ap_submit_evidence: 'အထောက်အထား တင်သွင်းရန်',

    ap_notify_board: 'အကြောင်းကြားစာ ဘုတ်',
    ap_forgot_password_title: 'စကားဝှက် မေ့နေပါသလား',
    ap_forgot_password: 'စကားဝှက် မေ့နေပါသလား',
    ap_phone_registered_placeholder: 'ယခင်မှတ်ပုံတင်ထားသော ဖုန်းနံပါတ်',
    ap_confirm_otp: 'OTP အတည်ပြုရန်',
    ap_otp_verify_alt: 'အထောက်အထား အတည်ပြုရန် OTP ကုဒ်ထည့်ပါ',
    ap_otp_4digit_placeholder: 'ကျေးဇူးပြု၍ ၄ လုံး OTP ထည့်ပါ',
    ap_confirm_password_title: 'ကျေးဇူးပြု၍ စကားဝှက် အတည်ပြုပါ',
    ap_enter_password_placeholder: 'ကျေးဇူးပြု၍ စကားဝှက်ထည့်ပါ',
    ap_found_problem: 'ပြဿနာ တွေ့ရှိပါသည်',
    ap_contact_support: 'ဖောက်သည်ဝန်ဆောင်မှုကို ဆက်သွယ်ပါ',
    ap_notify: 'အကြောင်းကြားချက်',
    ap_phone_placeholder: 'ဖုန်းနံပါတ်',
    ap_password_placeholder: 'စကားဝှက်',

    ap_choose_promo_before_topup: 'ငွေဖြည့်မီ ပရိုမိုးရှင်း ရွေးချယ်ပါ',
    ap_promo_default_alt: 'baccarat casino slot online promotion default',
    ap_problem: 'ပြဿနာ',
    ap_min_deposit_100: 'အနည်းဆုံး ငွေဖြည့် ၁၀၀',
    ap_min_deposit_10: 'အနည်းဆုံး ငွေဖြည့် ၁၀',
    ap_bank_prefix: 'ဘဏ် ',
    ap_use_registered_account_only: 'ကျေးဇူးပြု၍ မှတ်ပုံတင်ထားသော အကောင့်မှသာ လွှဲပါ။',
    ap_if_problem: 'ပြဿနာ ရှိပါက',
    ap_want_promo: 'ပရိုမိုးရှင်း ရယူလိုသည်',
    ap_min_deposit_dyn_prefix: 'အနည်းဆုံး ငွေဖြည့် ',
    ap_max_dyn_mid: ' အများဆုံး ',
    ap_baht_suffix: ' ဘတ်',
    ap_deposit_truemoney_title: 'TrueMoney ငွေသွင်းရန်',
    ap_enter_gift_link_placeholder: 'လက်ဆောင်လင့်ခ် ထည့်ပါ',
    ap_wallet_prefix: 'ပိုက်ဆံအိတ် ',

    ap_min_withdraw_1: 'အနည်းဆုံး ငွေထုတ် ၁',
    ap_credit_available: 'ရရှိနိုင်သော ခရက်ဒစ်',

    ap_account_info: 'အကောင့် အချက်အလက်',
    ap_change_password: 'စကားဝှက် ပြောင်းရန်',
    ap_current_password_placeholder: 'လက်ရှိ စကားဝှက်',
    ap_new_password_placeholder: 'စကားဝှက် အသစ်',
    ap_confirm_placeholder: 'အတည်ပြုချက်',
    ap_rank_condition_prefix: 'အဆင့် စည်းကမ်းချက် ',
    ap_deposit_more_prefix: 'နောက်ထပ် ',
    ap_member_benefit: 'Member အဆင့်သည် အထူးအခွင့်အရေးနှင့် ပိုမိုကောင်းမွန်သော ပရိုမိုးရှင်းများ ရရှိမည်။',
    ap_account_number_label: 'အကောင့်နံပါတ်：',
    ap_account_name_label: 'အကောင့်အမည်：',
    ap_change_account_contact: '*အကောင့်ပြောင်းလိုပါက ကျေးဇူးပြု၍',
    ap_use_coupon: 'ကူပွန် အသုံးပြုရန်',
    ap_coupon_code_placeholder: 'ကူပွန်ကုဒ်',

    ap_menu_account_info: 'အကောင့် အချက်အလက်',
    ap_menu_invite_friend: 'မိတ်ဆွေ ဖိတ်ခေါ်ရန်',
    ap_menu_cashback: 'ရှုံးငွေ ပြန်အမ်း',
    ap_menu_history: 'မှတ်တမ်း',
    ap_menu_history_full: 'ငွေလွှဲ မှတ်တမ်း',
    ap_menu_use_coupon: 'ကူပွန် အသုံးပြုရန်',
    ap_menu_joined_promo: 'ပါဝင်ခဲ့သော ပရိုမိုးရှင်း',
    ap_menu_logout: 'ထွက်ရန်',
    ap_logout_confirm_title: 'ထွက်လိုပါသလား။',
    ap_menu_cashback2: 'ရှုံးငွေ ပြန်အမ်း ရယူရန်',

    ap_get_cashback_bonus_prefix: 'ရှုံးငွေ ဘောနပ်စ် ရယူရန် ',
    ap_bonus_amount_period: 'ဤကာလအတွင်း ဘောနပ်စ် ပမာဏ ',
    ap_get_loss: 'ရှုံးငွေ ရယူရန်',
    ap_not_eligible: 'စည်းကမ်းနှင့် မကိုက်ညီပါ',
    ap_you_got_loss_prefix: 'သင် ရှုံးငွေ ဘောနပ်စ် ရရှိပါသည် ',
    ap_not_eligible_bonus: 'သင် ဘောနပ်စ်ရယူရန် စည်းကမ်းနှင့် မကိုက်ညီပါ။',
    ap_read_condition_join: 'ပါဝင်ရန် စည်းကမ်းချက်များကို ဖတ်ပါ',
    ap_below: 'အောက်တွင်။',
    ap_read_condition: 'စည်းကမ်းချက်များကို ဖတ်ပါ',
    ap_get_rank_bonus: 'Rank ဘောနပ်စ် ရယူရန်',
    ap_success: 'အောင်မြင်ပါသည်',
    ap_not_passed_condition: 'စည်းကမ်းချက် မပြည့်မီသေးပါ',

    ap_history_title: 'ငွေလွှဲ မှတ်တမ်း',
    ap_bonus_special: '*အထူး ဘောနပ်စ်',
    ap_status_label: 'အခြေအနေ：',
    ap_status_processing: 'ဆောင်ရွက်နေသည်',
    ap_status_pending: 'စောင့်ဆိုင်းနေသည်',
    ap_status_cancel_by_player: 'ပယ်ဖျက် (ကစားသမားမှ ပယ်ဖျက်)',
    ap_status_cancel_by_player_short: 'ပယ်ဖျက် (ကစားသမားမှ)',
    ap_status_fail_by_system: 'မအောင်မြင် (စနစ်မှ)',
    ap_status_success: 'အောင်မြင်ပါသည်',

    ap_invite_friend_title: 'မိတ်ဆွေ ဖိတ်ခေါ်ရန်',
    ap_get_invite_link: 'ဖိတ်ခေါ်လင့်ခ် ရယူရန်',
    ap_click_link: 'လင့်ခ်ကို နှိပ်ပါ ',
    ap_name_list: 'ရှိသော အမည်စာရင်း',
    ap_complete_min_deposit_100: 'အနည်းဆုံး ငွေဖြည့် ၁၀၀ ဘတ် စည်းကမ်းပြည့်မီပါပြီ ',
    ap_you_got_invite_credit: 'သင် မိတ်ဆွေဖိတ်ခေါ် ခရက်ဒစ် ရရှိပါသည်',
    ap_calc_every_sunday: 'ဘတ် (တနင်္ဂနွေတိုင်း ၀၀:၀၀ တွင် တွက်ချက်)',
    ap_you_got_percent: 'သင် ရာခိုင်နှုန်း ရရှိပါသည်  ',
    ap_from_loss_received: ' ရှုံးငွေမှ၊ ရရှိပမာဏ ',

    ap_cashback_title: 'ရှုံးငွေ ပြန်အမ်း',
    ap_cashback_condition: 'ရှုံးငွေ ပြန်အမ်း ရယူရန် စည်းကမ်း  ',
    ap_you_got_cashback: 'သင် ရှုံးငွေ ပြန်အမ်း ရရှိပါသည် ',
    ap_give_invite_credit: 'မိတ်ဆွေဖိတ်ခေါ် ခရက်ဒစ် ပေးသည်',
    ap_give_first_deposit_credit: 'ပထမဆုံး ငွေဖြည့် ခရက်ဒစ် ပေးသည်',
    ap_calc_every_sunday2: ' (တနင်္ဂနွေတိုင်း တွက်ချက်။)',

    ap_joined_promo: 'ပါဝင်ခဲ့သော ပရိုမိုးရှင်း',
    ap_get_bonus_not_open: 'ဘောနပ်စ် ရယူရန် (ဤပရိုမိုးရှင်း မဖွင့်ရသေးပါ)',
    ap_promo_not_open: 'ဤပရိုမိုးရှင်း မဖွင့်ရသေးပါ',
    ap_promo_rank_more: 'Rank တိုးရန် ပရိုမိုးရှင်း ',

    ap_promotion: 'ပရိုမိုးရှင်း',
    ap_promo_not_active: 'ပရိုမိုးရှင်း မဖွင့်ရသေးပါ',
    ap_get_promo: 'ပရိုမိုးရှင်း ရယူရန်',

    ap_bank_down: 'ယခု ဘဏ်စနစ် ချို့ယွင်းနေပါသည်',
    ap_sorry_inconvenience: 'အဆင်မပြေမှုအတွက် တောင်းပန်ပါသည်။',
    ap_2_months_ago: 'လွန်ခဲ့သော ၂ လ',
    ap_invite_more_get_more: 'ပိုဖိတ်ခေါ်လေ ပိုရလေ',
    ap_invite_friend_play: 'မိတ်ဆွေများကို ဖိတ်ခေါ်ကစားပါ၊ အများဆုံး ၃၀၀ ဘတ်၊ ၁၀ ဦး ပြည့်လျှင်',
    ap_get_extra_1000: 'နောက်ထပ် ၁၀၀၀ ဘတ် ချက်ချင်း ရရှိမည်',
    ap_contact_service: 'ထပ်မံမေးမြန်းရန် ဝန်ဆောင်မှု @betsup သို့ ဆက်သွယ်ပါ',
    ap_3_months_ago: 'လွန်ခဲ့သော ၃ လ',
    ap_delete_all: 'အားလုံး ဖျက်ရန်',

    ap_enter_game: 'ဂိမ်းသို့ ဝင်ရန်',
    ap_chrome_step1a: 'Google Chrome ကို ဖွင့်ပါ',
    ap_chrome_step1b: '"Label" ကို ရှာ၍ ဝဘ်ဆိုက်သို့',
    ap_chrome_step2a: 'နှိပ်ပါ ',
    ap_chrome_step2b: '"ပင်မစခရင်သို့ ထည့်ရန်" ကို ရွေးပါ',
    ap_chrome_step3a: '"ထည့်ရန်" ကိုနှိပ်၍ ဂိမ်းဖြတ်လမ်းကို',
    ap_chrome_step3b: 'ပင်မစခရင်သို့',
    ap_chrome_step4a: 'စာမျက်နှာကို စစ်ဆေးပါ',
    ap_chrome_step4b: 'ပင်မစခရင်တွင် အိုင်ကွန် ပေါ်လာသည်ကို',

    ap_baccarat: 'ဘက်ကာရာ',
    ap_casino: 'ကာစီနို',
    ap_wheel: 'ဘီးလှည့်',

    ap_promo_available: 'ရယူနိုင်သော ပရိုမိုးရှင်း',
    ap_cancel_promo: 'ပရိုမိုးရှင်း ပယ်ဖျက်ရန်',
    ap_receive_promo: 'ပရိုမိုးရှင်း ရယူရန်',
    ap_balance_remaining: 'ကျန်ငွေ',
    ap_turnover_label: 'တန်းအိုဗာ ',
    ap_transfer_within: 'ကျေးဇူးပြု၍ အောက်ပါအတွင်း လွှဲပါ：',
    ap_5_minutes: ' ၅ မိနစ်',
    ap_no_promo_text: 'ပရိုမိုးရှင်း မယူပါ',
    ap_after_transfer_press: 'လွှဲပြီးနောက် နှိပ်ရန် မမေ့ပါနှင့် ',
    ap_below_here: ' အောက်တွင်။',
    ap_edit_deposit_confirm: 'ငွေဖြည့်ပမာဏ ပြင်လိုပါသလား။',
    ap_upload_slip: 'ဖြတ်ပိုင်း တင်ရန်',
    ap_slip_max_5mb: 'ပုံ၏ အရွယ်အစား ၅MB ထက် မကျော်ရပါ',
    ap_slip_required_note: '**မဖြစ်မနေ** အခြားစခရင်မှ ဓာတ်ပုံမရိုက်ပါနှင့် ',
    ap_slip_qr_clear: 'ဖြတ်ပိုင်းတွင် ရှင်းလင်းစွာ',
    ap_and_must_see_qr: ' ပြီးလျှင် QRCode ကို မြင်ရမည်',

    ap_toprank: 'အဆင့်သတ်မှတ်ချက်',
    ap_strategy: 'ဗျူဟာ',
    ap_invite_friend_nav: 'မိတ်ဆွေ ဖိတ်ခေါ်ရန်',
    ap_join_promo: 'ပရိုမိုးရှင်း ပါဝင်ခြင်း',
    ap_you_got_loss_credit: 'သင် ရှုံးငွေ ခရက်ဒစ် ရရှိပါသည်',

    // ===== ap2_ =====
    ap2_ticker_main: 'Ae sexy အွန်လိုင်းကာစီနို၊ အွန်လိုင်းစလော့ – ပုံစံအမျိုးမျိုးဖြင့် ပျော်ရွှင်နိုင်စေသည်',
    ap2_footer_title_a: 'Ae sexyCASINO th အွန်လိုင်းကာစီနို ဝက်ဘ်ဆိုဒ် ',
    ap2_footer_title_b: 'ထိုင်းလူမျိုးတို့၏ နှလုံးသားတွင် ၃ နှစ်ဆက်တိုက် နံပါတ်တစ်',
    ap2_footer_content: 'Ae sexyCasino ဘက်ကာရာ၊ အကောင်းဆုံး အွန်လိုင်းကာစီနို၊ ကစားသူများအတွက် တကယ်ကောင်းမွန်သော အတွေ့အကြုံအတွက် Ae sexyCasino ပုံစံ',
    ap2_tag_casino: 'Ae sexy ကာစီနို',
    ap2_tag_casino_online: 'Ae sexy အွန်လိုင်းကာစီနို',
    ap2_tag_baccarat: 'Ae sexy ဘက်ကာရာ',
    ap2_tag_live_casino: 'တိုက်ရိုက်ကာစီနို',
    ap2_share_copied_msg: 'ကူးယူပြီးပါပြီ',
    ap2_share_caption: `🌎 AE Sexy၊ သင်ခံစားရမည့် နံပါတ်တစ်
🔥 အသင်းဝင်အသစ် ၁၀၀ သွင်းရင် ၁၅၀ ရ
🔥 အသင်းဝင်အသစ် ၃၀၀ သွင်းရင် ၅၀၀ ရ
🔥 အသင်းဝင်အသစ်များ ၅၀% ဘောနပ်စ်၊ အများဆုံး ၁,၀၀၀
🔥 ပရိုမိုးရှင်းပူပူ – ၁၀၀၀ သွင်းရင် ၁၀၀ အခမဲ့၊ စည်းကမ်းမရှိ
🔥 နိုင်ရင်ထပ်ပေး၊ ရှုံးရင် စနေနေ့တိုင်း ၅% ပြန်အမ်း၊ တစ်သက်လုံးရယူနိုင်
🎁 ၃ စက္ကန့်အတွင်း ငွေသွင်း-ထုတ်၊ ထိုင်းတွင် တစ်ခုတည်းသော တကယ်အသုံးဝင်သည့် AI စနစ်

#မျှဝေ၍ဝင်ငွေရ #နေ့တိုင်းရယူနိုင် #အားလုံးလုပ်နိုင် #အဆင့်နည်းနည်းဖြင့်လွယ်ကူ #ဝက်ဘ်ဆိုဒ်ကောင်းပရိုမိုးရှင်းပြင်း #နံပါတ်တစ် #aesexy #အမြန်ဆုံးငွေသွင်းထုတ်
#အကောင်းဆုံးAe`,
    ap2_tc_play_more_lose_back_prefix: 'နိုင်ရင်ထပ်ပေး၊ ရှုံးရင် ',
    ap2_tc_play_more_lose_back_suffix: ' % အပတ်စဉ်ပြန်အမ်း',
    ap2_tc_play_more_lose_back_5: 'နိုင်ရင်ထပ်ပေး၊ ရှုံးရင် အပတ်စဉ် ၅% ပြန်အမ်း',
    ap2_tc_calc_week_mon: '► ၁ ပတ်အတွင်း တွက်ချက်သည် (တနင်္လာ ၀၀:၀၁ မှ တနင်္ဂနွေ ၂၃:၅၉ အထိ)',
    ap2_tc_calc_week_sat: '► ၁ ပတ်အတွင်း တွက်ချက်သည် (စနေ ၀၀:၀၁ မှ သောကြာ ၂၃:၅၉ အထိ)',
    ap2_tc_turnover_5x: '► အပတ်အတွင်း ငွေသွင်းငွေ၏ ၅ ဆ တာဝန်ဝန်ဆောင်မှု (turnover) ရှိရမည်',
    ap2_tc_bonus_every_mon: '► ဘောနပ်စ်ကို တနင်္လာနေ့တိုင်း ပေးအပ်မည်၊ ဝက်ဘ်ဆိုဒ်တွင် ရယူနိုင်သည်',
    ap2_tc_bonus_every_sat: '► ဘောနပ်စ်ကို စနေနေ့တိုင်း ပေးအပ်မည်၊ ဝက်ဘ်ဆိုဒ်တွင် ရယူနိုင်သည်',
    ap2_tc_bonus_no_turnover: '► ရရှိသော ဘောနပ်စ်သည် turnover မလိုဘဲ ချက်ချင်းထုတ်ယူနိုင်သည်!',
    ap2_tc_min_winloss_500: '► တစ်ပတ်လျှင် နိုင်-ရှုံး ၅၀၀ ဘတ်ထက်ပိုမှသာ ၅% ဘောနပ်စ် ရရှိမည်',
    ap2_tc_min_winloss_2000: '► တစ်ပတ်လျှင် နိုင်-ရှုံး ၂၀၀၀ ဘတ်ထက်ပိုမှသာ ၅% ဘောနပ်စ် ရရှိမည်',
    ap2_tc_credit_expire_7: '► ပရိုမိုးရှင်းရယူပြီးနောက် ခရက်ဒစ်သက်တမ်းသည် ၇ ရက်ဖြစ်ပြီး ထို့နောက် ရှုံးငွေပြန်အမ်းခရက်ဒစ်ကို ၀ သို့ ပြောင်းလဲမည်',
    ap2_tc_credit_expire_3: '► ပရိုမိုးရှင်းရယူပြီးနောက် ခရက်ဒစ်သက်တမ်းသည် ၃ ရက်ဖြစ်ပြီး ထို့နောက် ရှုံးငွေပြန်အမ်းခရက်ဒစ်ကို ၀ သို့ ပြောင်းလဲမည်',
    ap2_tc_basic_rules: 'ဤပရိုမိုးရှင်းအတွက် အခြေခံစည်းကမ်းနှင့် စည်းမျဉ်းများ အကျုံးဝင်မည်',
    ap2_topup_word: 'သွင်း',
    ap2_topup_word_baht: ' ဘတ် ',
    ap2_topup_word_baht_more: ' ဘတ်အထက် ',
    ap2_bonus_word: 'ဘောနပ်စ် ',
    ap2_bonus_baht_invite: ' ဘတ်၊ သူငယ်ချင်းဖိတ် ',
    ap2_bonus_baht_only: ' ဘတ်',
    ap2_time_suffix: 'နာရီ',
    ap2_months_mini: ["ဇန်", "ဖေ", "မတ်", "ဧပြီ", "မေ", "ဇွန်", "ဇူ", "ဩ", "စက်", "အောက်", "နို", "ဒီ"],
  },
  lo: {
    ap_ok: 'ຕົກລົງ',
    ap_confirm: 'ຢືນຢັນ',
    ap_cancel: 'ຍົກເລີກ',
    ap_back: 'ກັບຄືນ',
    ap_back2: 'ກັບຄືນ',
    ap_next: 'ຕໍ່ໄປ',
    ap_copy: 'ສຳເນົາ',
    ap_copied: 'ສຳເນົາແລ້ວ',
    ap_copied_excl: 'ສຳເນົາແລ້ວ!',
    ap_acknowledge: 'ຮັບຊາບ',
    ap_done: 'ຮຽບຮ້ອຍ',
    ap_claim: 'ຮັບ',
    ap_baht: 'ບາດ',
    ap_credit_unit: 'ເຄຣດິດ',
    ap_login: 'ເຂົ້າສູ່ລະບົບ',
    ap_register: 'ສະໝັກສະມາຊິກ',
    ap_register_now: 'ສະໝັກເລີຍ',
    ap_login_short: 'ເຂົ້າລະບົບ',
    ap_deposit: 'ຝາກເງິນ',
    ap_withdraw: 'ຖອນເງິນ',
    ap_topup: 'ເຕີມເງິນ',
    ap_topup_payment: 'ເຕີມ Payment',
    ap_no_data: 'ບໍ່ພົບຂໍ້ມູນ',
    ap_no_history: 'ທ່ານຍັງບໍ່ມີຂໍ້ມູນການເຮັດລາຍການ.',
    ap_no_affiliate: 'ທ່ານຍັງບໍ່ມີຂໍ້ມູນການຊວນໝູ່.',
    ap_no_cashback: 'ທ່ານຍັງບໍ່ມີຂໍ້ມູນລາຍການເງິນຄືນ.',

    ap_withdraw_insufficient: 'ຍອດຖອນຂອງທ່ານບໍ່ພຽງພໍໃນການຖອນ.',
    ap_session_expired: 'Session ຂອງທ່ານໝົດອາຍຸ ກະລຸນາ login ເຂົ້າສູ່ລະບົບອີກຄັ້ງ.',
    ap_promo_pending_can_topup: 'ທ່ານໃຊ້ໂປຣໂມຊັນຄ້າງໄວ້ ສາມາດເຕີມເງິນໄດ້ເລີຍ.',
    ap_promo_received: 'ຮັບໂປຣໂມຊັນຮຽບຮ້ອຍ.',
    ap_promo_not_eligible: 'ທ່ານບໍ່ເຂົ້າເງື່ອນໄຂໂປຣໂມຊັນນີ້.',
    ap_quota_used_today: 'ທ່ານໃຊ້ສິດມື້ນີ້ຄົບແລ້ວ.',
    ap_promo_already_used: 'ທ່ານໃຊ້ໂປຣໂມຊັນນີ້ໄປແລ້ວ.',
    ap_processing_please_wait: 'ກະລຸນາລໍຖ້າ ກຳລັງດຳເນີນການ.',
    ap_enter_gift_link_min10: 'ກະລຸນາໃສ່ລິ້ງຂອງຂວັນດ້ານລຸ່ມ ຂັ້ນຕ່ຳ 10 ບາດ.',
    ap_truemoney_topup_success: 'ເຕີມເງິນສຳເລັດຈຳນວນ ',
    ap_gift_link_used: 'ລິ້ງຂອງຂວັນຖືກໃຊ້ງານໄປແລ້ວ ບໍ່ສາມາດໃຊ້ໄດ້.',
    ap_gift_link_not_yours: 'ລິ້ງເຕີມເງິນ ບໍ່ແມ່ນຊື່ບັນຊີຂອງທ່ານ ກະລຸນາກວດສອບ.',
    ap_truemoney_closed: 'ປິດລະບົບເຕີມເງິນທຣູ ລໍອັບເດດ.',
    ap_gift_link_failed: 'ເຮັດລາຍການບໍ່ສຳເລັດ ຫຼື ລິ້ງບໍ່ສາມາດໃຊ້ໄດ້. ',
    ap_no_gift_link: 'ທ່ານບໍ່ໄດ້ໃສ່ລິ້ງຂອງຂວັນ. ',
    ap_processing_please_wait2: 'ກຳລັງດຳເນີນການ ກະລຸນາລໍຖ້າ.',
    ap_scan_qr_within_5min: 'ກະລຸນາສະແກນ qrcode ພາຍໃນ 5 ນາທີ.',
    ap_min_deposit_prefix: 'ເຕີມຂັ້ນຕ່ຳ ',
    ap_max_deposit_mid: ' ບາດ ສູງສຸດ ',
    ap_claim_rank_question: 'ທ່ານຕ້ອງການຮັບ Rank ຫຼື ບໍ່?',
    ap_action_done: 'ດຳເນີນການຮຽບຮ້ອຍ.',
    ap_action_failed_wait: 'ບໍ່ສາມາດດຳເນີນການໄດ້ ກະລຸນາລໍຖ້າ.',
    ap_received_money_done: 'ເຮັດລາຍການຮັບເງິນຮຽບຮ້ອຍ.',
    ap_no_balance: 'ບໍ່ສາມາດເຮັດລາຍການໄດ້ ບໍ່ມີຍອດເງິນ.',
    ap_action_failed: 'ບໍ່ສາມາດເຮັດລາຍການໄດ້.',
    ap_password_changed: 'ປ່ຽນລະຫັດຜ່ານຮຽບຮ້ອຍ.',
    ap_old_password_wrong: 'ທ່ານໃສ່ລະຫັດເກົ່າຜິດພາດ.',
    ap_error_try_again: 'ມີຂໍ້ຜິດພາດ ກະລຸນາເຮັດລາຍການອີກຄັ້ງ.',
    ap_same_password: 'ທ່ານໃຊ້ລະຫັດເກົ່າ.',
    ap_password_mismatch: 'ທ່ານໃສ່ລະຫັດບໍ່ກົງກັນ.',
    ap_phone_invalid: 'ທ່ານໃສ່ເບີຜິດພາດ.',
    ap_phone_in_use: 'ເບີນີ້ມີຄົນໃຊ້ແລ້ວ.',
    ap_too_frequent: 'ທ່ານເຮັດລາຍການຖີ່ເກີນໄປ ກະລຸນາລໍຖ້າ.',
    ap_select_bank_or_complete: 'ກະລຸນາເລືອກທະນາຄານ ຫຼື ໃສ່ຂໍ້ມູນໃຫ້ຄົບຖ້ວນ !!',
    ap_otp_incomplete: 'ທ່ານໃສ່ຕົວເລກບໍ່ຄົບ.',
    ap_otp_wrong: 'ລະຫັດຜິດພາດ.',
    ap_phone_not_found: 'ບໍ່ມີເບີນີ້ໃນລະບົບ.',
    ap_withdraw_done: 'ລາຍການຖອນຮຽບຮ້ອຍ.',
    ap_withdraw_partial_prefix: 'ເຮັດລາຍການສຳເລັດ ທ່ານສາມາດຖອນໄດ້ບໍ່ເກີນ ',
    ap_withdraw_partial_suffix: ' ບາດເນື່ອງຈາກທ່ານຮັບໂບນັດ ເຄຣດິດສ່ວນທີ່ເຫຼືອເຮົາຈະຕັດອອກ.',
    ap_turnover_remaining_prefix: 'ທ່ານຕິດ Turnover ອີກ ',
    ap_turnover_remaining_suffix: ' ບາດ.',
    ap_withdraw_problem: 'ລາຍການຖອນມີບັນຫາ ກະລຸນາຕິດຕໍ່ພະນັກງານ.',
    ap_min_withdraw_100: 'ຂັ້ນຕ່ຳໃນການຖອນ 100 ບາດ.',
    ap_cancel_withdraw_question: 'ທ່ານຕ້ອງການຍົກເລີກການຖອນເງິນແມ່ນ ຫຼື ບໍ່?',
    ap_cancel_promo_question: 'ທ່ານຕ້ອງການຍົກເລີກການໃຊ້ໂປຣແມ່ນ ຫຼື ບໍ່?',
    ap_coupon_used_done: 'ດຳເນີນການໃຊ້ຄູປອງຮຽບຮ້ອຍ.',
    ap_coupon_not_found: 'ບໍ່ມີ Key ນີ້ໃນລະບົບ.',
    ap_force_withdraw_all: 'ບັງຄັບຖອນຍອດທັງໝົດ.',
    ap_not_login: ' ທ່ານບໍ່ໄດ້ເຮັດການ Login',
    ap_password_min6: 'Password ຂອງທ່ານບໍ່ຄົບ 6 ຕົວ ກະລຸນາກວດສອບ.',
    ap_no_phone_input: 'ທ່ານບໍ່ໄດ້ໃສ່ ເບີໂທລະສັບ.',
    ap_no_account_input: 'ທ່ານບໍ່ໄດ້ໃສ່ເລກບັນຊີທະນາຄານ.',
    ap_no_name_input: 'ທ່ານບໍ່ໄດ້ໃສ່ ຊື່-ນາມສະກຸນ.',
    ap_no_bank_selected: 'ທ່ານຍັງບໍ່ໄດ້ເລືອກທະນາຄານ.',
    ap_register_pass_mismatch: 'ທ່ານໃສ່ລະຫັດບໍ່ກົງກັນ.',
    ap_register_done_login: 'ເຮັດການສະໝັກຮຽບຮ້ອຍ ກະລຸນາ Log in ອີກຄັ້ງ.',
    ap_username_taken: 'Username ນີ້ເຮັດການສະໝັກໄປແລ້ວ.',
    ap_username_or_name_invalid: 'Username ຫຼື ຊື່ໃນການສະໝັກບໍ່ຖືກຕ້ອງ.',

    ap_share_earn_title: 'ແຊร์ແລກຊັບ',
    ap_share_earn_alt: 'ແຊร์ ແລກ ຊັບ',
    ap_go_to_page: 'ເຂົ້າໄປທີ່ເພຈ :',
    ap_share_pinned_post: 'ແລະແຊร์ໂພສທີ່ປັກໝຸດ',
    ap_copy_caption_hashtag: 'ສຳເນົາແຄັບຊັນ ແລະແຮັຊແທັກສຳລັບໃສ່ໃນໂພສ ແຕ່ງຄອມເມັນ',
    ap_paste_caption_hashtag: 'ພ້ອມວາງແຄັບຊັນແລະແຮັຊແທັກລົງໄປ',
    ap_fb_public_share: 'ໜ້າເຟຊບຸກເປີດສາທາລະນະ 1 ໂພສ , ແຊร์ລົງກຸ່ມ 2 ກຸ່ມ ແລະ',
    ap_like_page: 'ກົດໄລກ໌ເພຈ :',
    ap_copy_each_link: 'ພ້ອມສຳເນົາລິ້ງຂອງແຕ່ລະໂພສ',
    ap_attach_evidence_each: 'ເພື່ອນຳມາແນບໄຟລ໌ສົ່ງເປັນຫຼັກຖານ (ໂພສລະ 1 ລິ້ງ)',
    ap_share_complete_attach: 'ເມື່ອແຊร์ຄົບຕາມເງື່ອນໄຂແລ້ວ ກົດ "ແນບໄຟລ໌ເພື່ອຮັບສິດ"',
    ap_to_get_bonus: 'ເພື່ອຮັບໂບນັດ',
    ap_admin_check_next_day: 'ແອັດມິນຈະກວດສອບໂພສຈາກລິ້ງໃນມື້ຖັດໄປ',
    ap_credit_after_check: 'ແລະເຄຣດິດຈະເຂົ້າຫຼັງຈາກແອັດມິນກວດສຳເລັດທັນທີ',
    ap_no_evidence_forfeit: 'ແຕ່ຖ້າບໍ່ພົບຫຼັກຖານໃນລິ້ງຖືວ່າສະຫຼະສິດ ❌',
    ap_real_active_account: 'ຕ້ອງເປັນບັນຊີຈິງທີ່ມີການເຄື່ອນໄຫວ ແລະເປີດເປັນໂພສສາທາລະນະ',
    ap_for_verification: 'ເພື່ອການກວດສອບ',
    ap_fb_friends_300: 'ບັນຊີເຟຊບຸກທີ່ເຮັດແຊร์ແລກຊັບ ຕ້ອງມີໝູ່ຫຼາຍກວ່າ 300',
    ap_people_more: 'ຄົນຂຶ້ນໄປ',
    ap_group_public_1000: 'ກຸ່ມທີ່ເຮັດການແຊร์ຕ້ອງເປັນກຸ່ມສາທາລະນະແລະມີສະມາຊິກຫຼາຍກວ່າ 1,000',
    ap_people_more2: 'ຄົນຂຶ້ນໄປ',
    ap_limit_1_per_day: 'ຈຳກັດສິດ 1 ບຸກຄົນ 1 ຄັ້ງຕໍ່ມື້',
    ap_withdraw_share_condition: 'ສາມາດຖອນເຄຣດິດແຊร์ແລກຊັບໄດ້ ຕໍ່ເມື່ອຝາກຄົບ 500 ບາດຂຶ້ນໄປ',
    ap_within_14_days: 'ພາຍໃນ 14 ມື້',
    ap_member_must: 'ສະມາຊິກຕ້ອງ',
    ap_open_public_post: 'ເປີດເປັນໂພສສາທາລະນະ',
    ap_verify_or_forfeit: 'ເພື່ອການກວດສອບ ບໍ່ດັ່ງນັ້ນຈະຖືວ່າສະຫຼະສິດ',
    ap_copy_caption_comment: 'ສຳເນົາ ແຄັບຊັນ ແຮັຊແທັກ ສຳລັບໃສ່ໃນໂພສ ຄອມເມັນ',
    ap_paste_caption_hashtag2: 'ພ້ອມວາງແຄັບຊັນແຮັຊແທັກລົງໄປ',
    ap_share_now_good: 'ກົດ "ແຊร์ເລີຍ" ຈະມີສິ່ງດີໆ ເພື່ອແຊร์ໄປຍັງ facebook',
    ap_share_now: 'ແຊร์ເລີຍ',
    ap_attach_evidence_get: 'ແນບຫຼັກຖານ ເພື່ອຮັບສິດ',
    ap_bonus_wait_confirm: 'ຮັບໂບນັດແລະລໍຢືນຢັນ',
    ap_evidence_link1: 'ລິ້ງຫຼັກຖານ 1',
    ap_evidence_link2: 'ລິ້ງຫຼັກຖານ 2',
    ap_evidence_link3: 'ລິ້ງຫຼັກຖານ 3',
    ap_send_evidence: 'ສົ່ງຫຼັກຖານ',
    ap_submit_evidence: 'ສົ່ງຫຼັກຖານ',

    ap_notify_board: 'ກະດານແຈ້ງເຕືອນ',
    ap_forgot_password_title: 'ລືມລະຫັດຜ່ານ',
    ap_forgot_password: 'ລືມລະຫັດຜ່ານ',
    ap_phone_registered_placeholder: 'ເບີໂທລະສັບທີ່ເຄີຍລົງທະບຽນ',
    ap_confirm_otp: 'ຢືນຢັນ OTP',
    ap_otp_verify_alt: 'ກรอກລະຫัส OTP ເພື່ອຢືນຢັນຕົວຕົນ',
    ap_otp_4digit_placeholder: 'ກະລຸນາກรอກ OTP 4 ຫຼັກ',
    ap_confirm_password_title: 'ກະລຸນາ Confirm Password',
    ap_enter_password_placeholder: 'ກະລຸນາລະຫັດຜ່ານ',
    ap_found_problem: 'ພົບບັນຫາ',
    ap_contact_support: 'ຕິດຕໍ່ຝ່າຍບໍລິການລູກຄ້າ',
    ap_notify: 'ແຈ້ງເຕືອນ',
    ap_phone_placeholder: 'ເບີໂທລະສັບ',
    ap_password_placeholder: 'ລະຫັດຜ່ານ',

    ap_choose_promo_before_topup: 'ໜ້າເລືອກໂປຣກ່ອນເຕີມ',
    ap_promo_default_alt: 'baccarat casino slot online promotion default',
    ap_problem: 'ຕິດບັນຫາ',
    ap_min_deposit_100: 'ເງິນຝາກຂັ້ນຕ່ຳ 100',
    ap_min_deposit_10: 'ເງິນຝາກຂັ້ນຕ່ຳ 10',
    ap_bank_prefix: 'ທະນາຄານ ',
    ap_use_registered_account_only: 'ກະລຸນາໃຊ້ເລກບັນຊີທີ່ສະໝັກໂອນເຂົ້າມາເທົ່ານັ້ນ.',
    ap_if_problem: 'ຫາກພົບບັນຫາ',
    ap_want_promo: 'ຕ້ອງການຮັບໂປຣໂມຊັນ',
    ap_min_deposit_dyn_prefix: 'ເງິນຝາກຂັ້ນຕ່ຳ ',
    ap_max_dyn_mid: ' ສູງສຸດ ',
    ap_baht_suffix: ' ບາດ',
    ap_deposit_truemoney_title: 'ຝາກເງິນທຣູມັນນີ່',
    ap_enter_gift_link_placeholder: 'ໃສ່ລິ້ງຂອງຂວັນ',
    ap_wallet_prefix: 'ວໍເລັດ ',

    ap_min_withdraw_1: 'ເງິນຖອນຂັ້ນຕ່ຳ 1',
    ap_credit_available: 'ເຄຣດິດທີ່ມີ',

    ap_account_info: 'ຂໍ້ມູນບັນຊີ',
    ap_change_password: 'ປ່ຽນລະຫັດຜ່ານ',
    ap_current_password_placeholder: 'ລະຫັດຜ່ານປັດຈຸບັນ',
    ap_new_password_placeholder: 'ລະຫັດຜ່ານໃໝ່',
    ap_confirm_placeholder: 'ການຢືນຢັນ',
    ap_rank_condition_prefix: 'ເງື່ອນໄຂຂັ້ນ ',
    ap_deposit_more_prefix: 'ຝາກອີກ ',
    ap_member_benefit: 'ຂັ້ນ Member ຈະໄດ້ຮັບສິດທິພິເສດແລະໂປຣໂມຊັນທີ່ດີຍິ່ງຂຶ້ນ.',
    ap_account_number_label: 'ເລກບັນຊີ : ',
    ap_account_name_label: 'ຊື່ບັນຊີ : ',
    ap_change_account_contact: '*ຕ້ອງການປ່ຽນບັນຊີ ກະລຸນາ',
    ap_use_coupon: 'ໃຊ້ຄູປອງ',
    ap_coupon_code_placeholder: 'ລະຫັດຄູປອງ',

    ap_menu_account_info: 'ຂໍ້ມູນບັນຊີ',
    ap_menu_invite_friend: 'ຊวนໝູ່',
    ap_menu_cashback: 'ຄືນຍอดได้ເສຍ',
    ap_menu_history: 'ປະຫວັດ',
    ap_menu_history_full: 'ປະຫວັດເຮັດລາຍການ',
    ap_menu_use_coupon: 'ໃຊ້ຄູປອງ',
    ap_menu_joined_promo: 'ໂປຣໂມຊັນທີ່ເຂົ້າຮ່ວມ',
    ap_menu_logout: 'ອອກຈາກລະບົບ',
    ap_logout_confirm_title: 'ຕ້ອງການອອກຈາກລະບົບ ?',
    ap_menu_cashback2: 'ຮັບຄືນຍອດເສຍ',

    ap_get_cashback_bonus_prefix: 'ຮັບໂບນັດຍອດເສຍ ',
    ap_bonus_amount_period: 'ຍອດໂບນັດລະຫວ່າງວັນທີ ',
    ap_get_loss: 'ຮັບຍອດເສຍ',
    ap_not_eligible: 'ບໍ່ເຂົ້າເງື່ອນໄຂ',
    ap_you_got_loss_prefix: 'ທ່ານໄດ້ຮັບຍອດເສຍ ',
    ap_not_eligible_bonus: 'ທ່ານບໍ່ເຂົ້າເງື່ອນໄຂການຮັບໂບນັດ.',
    ap_read_condition_join: 'ກະລຸນາອ່ານເງື່ອນໄຂການເຂົ້າຮ່ວມ',
    ap_below: 'ດ້ານລຸ່ມ.',
    ap_read_condition: 'ກະລຸນາອ່ານເງື່ອນໄຂ',
    ap_get_rank_bonus: 'ຂໍຮັບໂບນັດ Rank',
    ap_success: 'ສຳເລັດ',
    ap_not_passed_condition: 'ຍັງບໍ່ຜ່ານເງື່ອນໄຂ',

    ap_history_title: 'ປະຫວັດການເຮັດລາຍການ',
    ap_bonus_special: '*ໂບນັດພິເສດ',
    ap_status_label: 'ສະຖານະ : ',
    ap_status_processing: 'ກຳລັງດຳເນີນການ',
    ap_status_pending: 'ລໍດຳເນີນການ',
    ap_status_cancel_by_player: 'ຍົກເລີກ (ຍົກເລີກໂດຍຜູ້ຫຼິ້ນ)',
    ap_status_cancel_by_player_short: 'ຍົກເລີກ (ໂດຍຜູ້ຫຼິ້ນ)',
    ap_status_fail_by_system: 'ບໍ່ສຳເລັດ (ໂດຍລະບົບ)',
    ap_status_success: 'ສຳເລັດ',

    ap_invite_friend_title: 'ຊวนໝູ່',
    ap_get_invite_link: 'ຮັບລິ້ງຊวนໝູ່',
    ap_click_link: 'ກົດທີ່ລິ້ງ ',
    ap_name_list: 'ລາຍຊື່ທີ່ມີ',
    ap_complete_min_deposit_100: 'ຄົບເງື່ອນໄຂການເຕີມເງິນຂັ້ນຕ່ຳ 100 ບາດແລ້ວ ',
    ap_you_got_invite_credit: 'ທ່ານໄດ້ຮັບເຄຣດິດຊวนໝູ່',
    ap_calc_every_sunday: 'ບາດ (ຄຳນວນທຸກວັນອາທິດ ເວລາ 00.00ນ.)',
    ap_you_got_percent: 'ທ່ານໄດ້ເປີເຊັນ  ',
    ap_from_loss_received: ' ຈາກຍອດເສຍ ຍອດໄດ້ຮັບ ',

    ap_cashback_title: 'ຄືນຍอดได้ເສຍ',
    ap_cashback_condition: 'ເງື່ອນໄຂ ຮັບຍอดได้ເສຍ  ',
    ap_you_got_cashback: 'ທ່ານໄດ້ຮັບຄືນຍອດເສຍຈຳນວນ ',
    ap_give_invite_credit: 'ໃຫ້ເຄຣດິດຊวนໝູ່',
    ap_give_first_deposit_credit: 'ໃຫ້ເຄຣດິດເຕີມຄັ້ງທຳອິດ',
    ap_calc_every_sunday2: ' (ຄຳນວນທຸກວັນອາທິດ.)',

    ap_joined_promo: 'ໂປຣໂມຊັນທີ່ເຂົ້າຮ່ວມ',
    ap_get_bonus_not_open: 'ຂໍຮັບໂບນັດ (ຍັງບໍ່ເປີດໃຊ້ໂປຣໂມຊັນນີ້)',
    ap_promo_not_open: 'ຍັງບໍ່ເປີດໃຊ້ໂປຣໂມຊັນນີ້',
    ap_promo_rank_more: 'ໂປຣໂມຊັນເພີ່ມ Rank ',

    ap_promotion: 'ໂປຣໂມຊັນ',
    ap_promo_not_active: 'ໂປຣໂມຊັນຍັງບໍ່ໄດ້ເປີດໃຊ້ງານ',
    ap_get_promo: 'ຮັບໂປຣໂມຊັນ',

    ap_bank_down: 'ຂณะนี້ທະນາຄານຂັດຂ້ອງ',
    ap_sorry_inconvenience: 'ຂໍອະໄພໃນຄວາມບໍ່ສະດວກ.',
    ap_2_months_ago: '2 ເດືອນທີ່ແລ້ວ',
    ap_invite_more_get_more: 'ຍິ່ງຊวนຍิ່ງໄດ້',
    ap_invite_friend_play: 'ແນະນຳໝູ່ມາຫຼິ້ນ ຮັບສູງສຸດ 300 ບາດ ຊวนຄົບ 10 ຄົນ',
    ap_get_extra_1000: 'ຮັບເພີ່ມທັນທີອີກ 1000 ບາດ',
    ap_contact_service: 'ສອບຖາມເພີ່ມເຕີມໄດ້ທີ່ຝ່າຍບໍລິການ @betsup',
    ap_3_months_ago: '3 ເດືອນທີ່ແລ້ວ',
    ap_delete_all: 'ລົບທັງໝົດ',

    ap_enter_game: 'ເຂົ້າສູ່ເກມ',
    ap_chrome_step1a: 'ເຂົ້າ Google Chrome ແລ້ວ',
    ap_chrome_step1b: 'Search "Label" ເຂົ້າສູ່ໜ້າເວັບ',
    ap_chrome_step2a: 'ກົດທີ່ ',
    ap_chrome_step2b: 'ເລືອກ "ເພີ່ມລົງໃນໜ້າຈໍຫຼັກ"',
    ap_chrome_step3a: 'ກົດ "ເພີ່ມ" ທາງລັດເຂົ້າສູ່ເກມ',
    ap_chrome_step3b: 'ລົງໃນໜ້າຈໍໂຮມ',
    ap_chrome_step4a: 'ກວດສອບໜ້າ',
    ap_chrome_step4b: 'ໂຮມສະກรีนว่ามีໄອຄອນຂຶ້ນແລ້ວ',

    ap_baccarat: 'ບາຄາร่า',
    ap_casino: 'ຄາສິໂນ',
    ap_wheel: 'ກงล้อ',

    ap_promo_available: 'ໂປຣໂມຊັນທີ່ຮັບໄດ້',
    ap_cancel_promo: 'ຍົກເລີກໂປຣໂມຊັນ',
    ap_receive_promo: 'ຮັບໂປຣໂມຊັນ',
    ap_balance_remaining: 'ເງິນຄงเหลือ',
    ap_turnover_label: 'ເທີນໂອເວີ ',
    ap_transfer_within: 'ກະລຸນາໂອນພາຍໃນ : ',
    ap_5_minutes: ' 5 ນາທີ',
    ap_no_promo_text: 'ບໍ່ຮັບໂປຣໂມຊັນ',
    ap_after_transfer_press: 'ເມື່ອໂອນແລ້ວ ຢ່າລືມກົດ ',
    ap_below_here: ' ດ້ານລຸ່ມນີ້.',
    ap_edit_deposit_confirm: 'ຕ້ອງການແກ້ໄຂຍອດຝາກ ?',
    ap_upload_slip: 'ອັປໂຫຼດສລິບ',
    ap_slip_max_5mb: 'ຮູບຈະຕ້ອງມີຂະໜາດບໍ່ເກີນ 5MB',
    ap_slip_required_note: '**ຈຳເປັນ** ຫ້າມຖ່າຍຮູບຈากໜ້າຈໍອື່ນ ',
    ap_slip_qr_clear: 'ໃນສລິບชัดເຈນ',
    ap_and_must_see_qr: ' ແລະ ຕ້ອງເຫັນ QRCode',

    ap_toprank: 'ຈັດອັນດັບ',
    ap_strategy: 'ກລະຍຸດ',
    ap_invite_friend_nav: 'ຊวนໝູ່',
    ap_join_promo: 'ການເຂົ້າຮ່ວມໂປຣໂມຊັນ',
    ap_you_got_loss_credit: 'ທ່ານໄດ້ຮັບເຄຣດິດຍອດເສຍ',

    // ===== ap2_ =====
    ap2_ticker_main: 'Ae sexy ຄາສິໂນອອນລາຍ ສລ໋ອດອອນລາຍ ທີ່ໃຫ້ທ່ານມ່ວນຊື່ນໄດ້ທຸກຮູບແບບ',
    ap2_footer_title_a: 'Ae sexyCASINO th ເວັບຄາສິໂນອອນລາຍ ',
    ap2_footer_title_b: 'ຄອງອັນດັບໃນໃຈຄົນໄທ 3 ປີຊ້ອນ',
    ap2_footer_content: 'Ae sexyCasino ບາກາຣ່າ ຄາສິໂນອອນລາຍ ທີ່ດີທີ່ສຸດ ເພື່ອປະສົບການທີ່ດີຂອງຜູ້ຫຼິ້ນຢ່າງແທ້ຈິງ ແບບ Ae sexyCasino',
    ap2_tag_casino: 'Ae sexy ຄາສິໂນ',
    ap2_tag_casino_online: 'Ae sexy ຄາສິໂນອອນລາຍ',
    ap2_tag_baccarat: 'Ae sexy ບາກາຣ່າ',
    ap2_tag_live_casino: 'ຄາສິໂນສົດ',
    ap2_share_copied_msg: 'ສຳເນົາແລ້ວ',
    ap2_share_caption: `🌎 AE Sexy ອັນດັບໜຶ່ງທີ່ທ່ານຕ້ອງສຳຜັດ
🔥 ສະມາชิກໃໝ່ 100 ຮັບ 150
🔥 ສະມาชิກໃໝ່ 300 ຮັບ 500
🔥 ສະມາชิກໃໝ່ຮັບໂບນັส 50% ສູງສຸດ 1,000
🔥 ໂປຣຮ້ອນແຮง ຝາກ 1000 ຟຣີ 100 ບໍ່ติດເງື່ອນໄຂ
🔥 ຫຼິ້ນໄດ້ໃຫ້ເພີ່ມ ຫຼິ້ນເສຍคืນໃຫ້ 5% ທຸກວັນເສົາ ຮັບໄດ້ຕະຫຼອດชีວิต
🎁 ຝາກ - ຖอน 3 ວິ ດ້ວຍລະບົບ AI ທີ່ໃช้ໄດ້ຈິງເຈົ້າດຽວໃນไทย

#ແชร์ແลกຊັບ #ຮັບໄດ້ທຸກວັນ #ເຮັດໄດ້ທຸກຄົນ #ເຮັດง่າຍບໍ່ກີ່ຂັ້ນຕอน #ເວັບດີໂປຣແຮง #ອັນດັບໜຶ່ງ #aesexy #ຝາກຖอนໄວສຸด
#aeที่ดีที่สุด`,
    ap2_tc_play_more_lose_back_prefix: 'ຫຼິ້ນໄດ້ໃຫ້ເພີ່ມ ຫຼິ້ນເສຍໃຫ້ຄືນ ',
    ap2_tc_play_more_lose_back_suffix: ' % ທຸກອາທິດ',
    ap2_tc_play_more_lose_back_5: 'ຫຼິ້ນໄດ້ໃຫ້ເພີ່ມ ຫຼິ້ນເສຍໃຫ້ຄືນ 5% ທຸກອາທິດ',
    ap2_tc_calc_week_mon: '► คำนวณຍอดใน 1 ອາທິດ (ตั้ງແต่ ຈັນ 00:01 ฮอด ວັນອາທິດ 23:59)',
    ap2_tc_calc_week_sat: '► คำนวณຍอดใน 1 ອາທິດ (ตั้ງແต่ ເສົາ 00:01 ฮอด ວັນສຸກ 23:59)',
    ap2_tc_turnover_5x: '► ຕ້ອງມີຍອດເທີນໂອເວີ 5 ເທົ່າຂອງເງິນຝາກພາຍໃນອາທິດ',
    ap2_tc_bonus_every_mon: '► ໂບນັສຈະໄດ້ຮັບທຸກວັນຈັນ ສາມາດກົດຮັບໂບນັສໄດ້ທີ່ໜ້າເວັບ',
    ap2_tc_bonus_every_sat: '► ໂບນັສຈະໄດ້ຮັບທຸກວັນເສົາ ສາມາດກົດຮັບໂບນັສໄດ້ທີ່ໜ້າເວັບ',
    ap2_tc_bonus_no_turnover: '► ໂບນັສທີ່ໄດ້ຮັບບໍ່ຕ້ອງເຮັດເທີນໂອເວີ ຖอนໄດ້ທັນທີ!',
    ap2_tc_min_winloss_500: '► ມີຍອດໄດ້-ເສຍຫຼາຍກວ່າ 500 ບາດຕໍ່ອາທິດ ຈຶ່ງຈະໄດ້ຮັບໂບນັສ 5%',
    ap2_tc_min_winloss_2000: '► ມີຍອດໄດ້-ເສຍຫຼາຍກວ່າ 2000 ບາດຕໍ່ອາທິດ ຈຶ່ງຈະໄດ້ຮັບໂບນັສ 5%',
    ap2_tc_credit_expire_7: '► ເມື່ອຮັບໂປຣໂມຊັນ ເຄຣດິດຈະມີອາຍຸການใช้ງານ 7 ມື້ ຈากนั้นເຄຣດິດคืນຍอดເສຍຈะถูກປັບເປັນ 0',
    ap2_tc_credit_expire_3: '► ເມື່ອຮັບໂປຣໂມຊັນ ເຄຣດິດຈະມີອາຍຸການใช้ງານ 3 ມື້ ຈากนั้นເຄຣດິດคืນຍอดເສຍຈะถูກປັບເປັນ 0',
    ap2_tc_basic_rules: 'ເງື່ອນໄຂແລະກະຕິກາພື້ນຖານຈະຖືກນຳມາໃช้ກັບໂປຣໂມຊັນนี้',
    ap2_topup_word: 'ຝາກ',
    ap2_topup_word_baht: ' ບາດ ',
    ap2_topup_word_baht_more: ' ບາດຂຶ້ນไป ',
    ap2_bonus_word: 'ໂບນັສ ',
    ap2_bonus_baht_invite: ' ບາດ ຊวนໝູ່ ',
    ap2_bonus_baht_only: ' ບາດ',
    ap2_time_suffix: 'ໂມງ',
    ap2_months_mini: ["ມ.ກ.", "ກ.ພ.", "ມ.ນ.", "ມ.ສ.", "ພ.ພ.", "ມິ.ຖ.", "ກ.ລ.", "ສ.ຫ.", "ກ.ຍ.", "ຕ.ລ.", "ພ.ຈ.", "ທ.ວ."],
  },
};

Object.keys(ext).forEach((l) => { translations[l] = Object.assign({}, translations[l], ext[l]); });

export default ext;
